(function () {
  "use strict";

  var CONFIG = Object.assign({
    formEndpoint: "",
    consultationEndpoint: "",
    publicUrl: "",
    collectionsUrl: "https://andrewgeoghegan.com/collections/designer-engagement-rings",
    contactUrl: "https://andrewgeoghegan.com/pages/contact",
    source: "ring-direction-design-brief",
    version: "3.8.0-reference-roles",
    // Leave blank in preview. Production values are supplied through
    // window.ERDB_CONFIG, never hard-coded into the public page.
    hubspotPortalId: "",
    hubspotBriefFormGuid: "",
    hubspotDeliveryFormGuid: "",
    hubspotMarketingSubscriptionTypeId: "",
    hubspotBriefProperty: "ring_design_brief_json",
    briefServiceEndpoint: "https://ring-design-brief-service.vercel.app/api/briefs"
  }, window.ERDB_CONFIG || {});

  // Image files are deliberately supplied separately from this direction build.
  // Add window.ERDB_ASSETS before this module to populate visual asset slots.
  // Collection overrides may be supplied as collection-<family>,
  // collection-<family>-<metal>, collection-<family>-<colour>, or
  // collection-<family>-<metal>-<colour>. The final form wins, so a checked
  // product image can be matched to a result without changing this engine.
  var assets = Object.assign({
    chairs: "./visual-source-images/original-generated-2026-07-19/ag-original-chair-archetypes-strip.png?v=20260720-visualqa6",
    paintings: "./visual-source-images/original-generated-2026-07-19/ag-original-colour-studies-strip-v2.png?v=20260804-colourqa1",
    "metal-white": "./visual-source-images/andy-selected-2026-07-19/review-assets/metal-20260807-white.png",
    "metal-yellow": "./visual-source-images/andy-selected-2026-07-19/review-assets/metal-20260807-yellow.png",
    "metal-rose": "./visual-source-images/andy-selected-2026-07-19/review-assets/metal-20260807-rose.png",
    "metal-two": "./visual-source-images/andy-selected-2026-07-19/review-assets/metal-20260807-two.png",
    "metal-open": "./visual-source-images/andy-selected-2026-07-19/review-assets/metal-20260807-open.png",
    "collection-cannele-yellow": "https://andrewgeoghegan.com/cdn/shop/files/cannele-petit-diamond-678312.jpg?v=1723265974&width=1200",
    "collection-cannele-rose": "https://andrewgeoghegan.com/cdn/shop/files/cannele-chocolate-644674.jpg?v=1723636061&width=1200",
    "collection-cannele-twist-white": "https://andrewgeoghegan.com/cdn/shop/files/cannele-twist-diamond-364550.jpg?v=1723266150&width=1200",
    "collection-emergence-white": "https://andrewgeoghegan.com/cdn/shop/files/emergence-flow-diamond-solitaire-642933.jpg?v=1728631058&width=1200",
    "collection-embrace-white": "https://andrewgeoghegan.com/cdn/shop/files/embrace-923780.jpg?v=1731365576&width=1200",
    "collection-embrace-yellow": "https://andrewgeoghegan.com/cdn/shop/files/embrace-402339.jpg?v=1731365576&width=1200",
    "collection-embrace-rose": "https://andrewgeoghegan.com/cdn/shop/files/embrace-118088.jpg?v=1731365576&width=1200",
    "collection-satellite-white": "https://andrewgeoghegan.com/cdn/shop/files/satellite-diamond-546459.jpg?v=1734100171&width=1200",
    "collection-satellite-yellow": "https://andrewgeoghegan.com/cdn/shop/files/satellite-diamond-707314.jpg?v=1731365643&width=1200",
    "collection-satellite-rose": "https://andrewgeoghegan.com/cdn/shop/files/satellite-diamond-332984.jpg?v=1731365643&width=1200",
    "collection-lacuna-white": "https://andrewgeoghegan.com/cdn/shop/files/lacuna-962956.jpg?v=1728631118&width=1200",
    "collection-lacuna-yellow": "https://andrewgeoghegan.com/cdn/shop/files/lacuna-851316.jpg?v=1728631118&width=1200",
    "collection-lacuna-rose": "https://andrewgeoghegan.com/cdn/shop/files/lacuna-190269.jpg?v=1728631118&width=1200",
    "collection-clair-de-lune-white": "https://andrewgeoghegan.com/cdn/shop/files/clair-de-lune-diamond-ring-319933.jpg?v=1725972849&width=1200",
    "collection-clair-de-lune-yellow": "https://andrewgeoghegan.com/cdn/shop/files/clair-de-lune-diamond-ring-335150.jpg?v=1725972849&width=1200",
    "collection-clair-de-lune-rose": "https://andrewgeoghegan.com/cdn/shop/files/clair-de-lune-diamond-ring-198818.jpg?v=1725972849&width=1200",
    "collection-infinity": "./image-catalogue-batch-03/infinity-aquamarine.jpg"
  }, window.ERDB_ASSETS || {});

  function assetUrl(key) {
    return typeof assets[key] === "string" ? assets[key].trim() : "";
  }

  function collectionImageFor(collection, answers) {
    var prefix = "collection-" + collection.id;
    var metal = answers && answers.metal && answers.metal !== "open" ? answers.metal : "";
    var colour = answers && answers.colour && answers.colour !== "open" ? answers.colour : "";
    var keys = [];
    if (metal && colour) keys.push(prefix + "-" + metal + "-" + colour);
    if (metal) keys.push(prefix + "-" + metal);
    if (colour) keys.push(prefix + "-" + colour);
    keys.push(prefix);
    for (var i = 0; i < keys.length; i += 1) {
      var supplied = assetUrl(keys[i]);
      if (supplied) return supplied;
    }
    return collection.image;
  }

  var bespokeExamples = Array.isArray(window.ERDB_BESPOKE_EXAMPLES)
    ? window.ERDB_BESPOKE_EXAMPLES
    : [];

  var state = {
    current: 0,
    answers: {},
    practical: {},
    contact: {},
    result: null,
    lastPayload: null,
    lastConsultationPayload: null
  };

  var uploadPreviewUrl = "";

  var subjectWeights = {
    wearer: { wearer: 0.80, relationship: 0.20 },
    relationship: { wearer: 0.45, relationship: 0.55 },
    private: { wearer: 0.65, relationship: 0.35 },
    balance: { wearer: 0.50, relationship: 0.50 }
  };

  // A provisional, reviewable hypothesis. These values say which quality can
  // lead within each AG design language. They must be validated against
  // Andrew's judgement before the model is treated as commercially reliable.
  var wholeRingFitByCollection = {
    "cannele":       { light: 72, structure: 96, depth: 94, restraint: 62 },
    "cannele-twist": { light: 78, structure: 92, depth: 88, restraint: 45 },
    "asteria":       { light: 100, structure: 82, depth: 76, restraint: 56 },
    "satellite":     { light: 88, structure: 76, depth: 68, restraint: 48 },
    "chapiteau":     { light: 94, structure: 100, depth: 82, restraint: 34 },
    "clair-de-lune": { light: 96, structure: 76, depth: 88, restraint: 38 },
    "embrace":       { light: 68, structure: 84, depth: 82, restraint: 76 },
    "emergence":     { light: 82, structure: 94, depth: 92, restraint: 30 },
    "empress":       { light: 92, structure: 82, depth: 64, restraint: 54 },
    "lacuna":        { light: 70, structure: 98, depth: 98, restraint: 70 },
    "theia":         { light: 96, structure: 86, depth: 86, restraint: 38 }
  };

  var questions = [
    {
      id: "subject",
      kicker: "The design's focus",
      title: "What should the ring express most clearly?",
      help: "This decides what the design should focus on: the wearer, the relationship or both. Both may matter, but the brief needs to know what should lead.",
      type: "single",
      options: [
        { id: "wearer", label: "The wearer", description: "It should primarily express the character and style of the person who will wear it." },
        { id: "relationship", label: "The relationship", description: "It should express something essential about the relationship." },
        { id: "private", label: "The wearer, with the relationship woven into the design", description: "The wearer should lead, with something meaningful about the relationship included more subtly." },
          { id: "balance", label: "The wearer and the relationship equally", description: "The wearer’s personal style and what the relationship means should carry equal weight." }
      ]
    },
    {
      id: "evidence",
      kicker: "The evidence",
      title: "How are you making these choices?",
      help: "This helps to indicate how directly the answers reflect the wearer's own style.",
      type: "single",
      options: [
        { id: "wearer", label: "I am choosing for myself", description: "I know what will look right on my own hand.", factor: 1.00 },
        { id: "together", label: "We are both involved in these answers", description: "We are making the decisions together.", factor: 1.00 },
        { id: "direct", label: "I have access to ring images they have suggested", description: "I have direct visual clues from them.", factor: 0.90, groupBefore: "I am choosing for my partner:" },
        { id: "observed", label: "I am drawing inspiration from the jewellery, clothes and objects they already choose", description: "Their existing choices are guiding me.", factor: 0.75 },
        { id: "confident", label: "I have a good sense of their style, but very few direct ring clues", description: "I know their wider style better than their taste in rings.", factor: 0.70 },
        { id: "limited", label: "I am not yet clear about their style", description: "This brief can help identify what is known and what still needs exploring.", factor: 0.55 }
      ]
    },
    {
      id: "presence",
      kicker: "The wearer",
      title: "How much presence should the ring have on the hand?",
      help: "This is only about how noticeable the finished ring should be on the hand. Use the spotlights as a scale from quiet to unmistakable. Choose the level of presence the ring should have, not the spotlight image you like best.",
      type: "single",
      layout: "visual",
      options: [
        { id: "quiet", label: "Quiet glow", description: "A refined point of light. Subtle, personal and quietly present.", target: { P: 15 }, asset: "presence-lights", assetPosition: "0.25%" },
        { id: "assured", label: "Assured presence", description: "A broader, brighter presence. Clearly noticeable without needing to dominate.", target: { P: 40 }, asset: "presence-lights", assetPosition: "33.18%" },
        { id: "expressive", label: "Expressive brilliance", description: "Bold and commanding. Designed to be clearly seen and remembered.", target: { P: 70 }, asset: "presence-lights", assetPosition: "66.33%" },
        { id: "unmistakable", label: "Unmistakable impact", description: "Dazzling and extraordinary. A ring that immediately commands attention.", target: { P: 95 }, asset: "presence-lights", assetPosition: "99.4%" }
      ]
    },
    {
      id: "wholeRing",
      kicker: "The whole ring",
      title: "What should give the ring its strongest character?",
      help: "Every element of an engagement ring should be deeply considered during the design stage: the setting, profile and band, and how they work together as one complete piece.",
      type: "single",
      options: [
        { id: "light", label: "Light and the stones", description: "Brightness, colour and the way the ring plays with light." },
          { id: "structure", label: "The form and lines of the ring itself", description: "The overall shape, proportions and the transition from setting into band." },
        { id: "depth", label: "Depth, space and shadow", description: "Openings, layers and details that become apparent as the hand moves." },
        { id: "restraint", label: "Clarity and restraint", description: "A resolved form with very little additional detail." }
      ]
    },
    {
      id: "originality",
      kicker: "The form",
      title: "What kind of design character should the ring have?",
      help: "The chairs make it easier to compare different design characters before looking at rings. Look past the chair itself and choose the description that feels closest: classical, distinctive, architectural, asymmetric or naturally flowing.",
      type: "single",
      layout: "visual-five",
      options: [
        { id: "classical", label: "Recognisably classical and beautifully resolved", target: { O: 10, G: 20, A: 0, M: 10 }, asset: "chairs", assetPosition: "1.3%" },
        { id: "departure", label: "A recognisably classical form with one distinctive feature", target: { O: 45, G: 35, A: 25, M: 55 }, asset: "chairs", assetPosition: "25.6%" },
        { id: "architectural", label: "Architectural and original, but still recognisable", target: { O: 65, G: 100, A: 0, M: 10 }, asset: "chairs", assetPosition: "50%" },
        { id: "asymmetric", label: "Asymmetric and deliberately unconventional", target: { O: 90, G: 50, A: 100, M: 75 }, asset: "chairs", assetPosition: "74.4%" },
          { id: "talismanic", label: "A design with a continuous, natural sense of flow", target: { O: 100, G: 45, A: 60, M: 100 }, asset: "chairs", assetPosition: "98.7%" }
      ]
    },
    {
      id: "colour",
      kicker: "The stone language",
      title: "What role should colour play?",
      help: "The artworks make the role of colour easier to compare without asking you to choose a gemstone yet. Look past the particular colours and choose whether the ring should be diamond-led, carry a restrained colour, place colour at its centre, create a dialogue between two colours, or keep colour open.",
      type: "single",
      layout: "visual-five",
      options: [
        { id: "white", label: "White light should lead", description: "Diamond-led, with colour playing little or no part.", target: { C: 0 }, asset: "paintings", assetPosition: "0.8%" },
        { id: "accent", label: "A restrained note of colour", description: "A quiet accent, not the whole identity.", target: { C: 30 }, asset: "paintings", assetPosition: "25.5%" },
        { id: "centre", label: "A coloured stone should be the emotional centre", description: "Colour carries the first impression.", target: { C: 90 }, asset: "paintings", assetPosition: "49.9%" },
        { id: "dialogue", label: "Two colours or stones should speak to one another", description: "The pairing is part of the meaning.", target: { C: 100, T: 100 }, asset: "paintings", assetPosition: "74.5%" },
        { id: "open", label: "Keep this open until the design direction is clearer", description: "Colour should follow the brief rather than lead it.", open: true, asset: "paintings", assetPosition: "99%" }
      ]
    },
    {
      id: "metal",
      kicker: "Metal colour",
      title: "Which metal direction would suit the wearer?",
      help: "Think about the jewellery they already choose and how different metals sit against their skin. The metal may also influence the choice of coloured stone.",
      note: "Skin tone is a clue, not a rule. Sun exposure can change visible complexion through the year. Existing jewellery, personal preference, daylight and the chosen stone are stronger evidence than a rigid formula.",
      type: "single",
      layout: "visual-five",
      options: [
        { id: "white", label: "Cool and luminous", description: "Platinum or white gold. Often crisp with cooler undertones.", image: "metal-white" },
        { id: "yellow", label: "Warm and rich", description: "Yellow gold. Often harmonious with warmer or olive undertones.", image: "metal-yellow" },
        { id: "rose", label: "Softly warm", description: "Rose gold. A gentler warmth across a broad range of complexions.", image: "metal-rose" },
        { id: "two", label: "A considered contrast", description: "Two metals can bridge warmth and coolness or reflect jewellery already worn.", image: "metal-two" },
        { id: "open", label: "Keep this open", description: "Decide with Andrew alongside the actual stone and design.", image: "metal-open", open: true }
      ]
    },
    {
      id: "symbolism",
      kicker: "The design's focus",
      title: "How much should the relationship influence the design?",
      help: "The wearer is always part of the brief. This asks whether something meaningful about the relationship should also shape the ring, and by how much.",
      type: "single",
      options: [
        { id: "form", label: "Let the wearer lead", description: "Their character and style should shape the ring. The relationship gives it meaning, but does not need to affect how it looks.", target: { L: 0, T: 0 } },
        { id: "discreet", label: "Include the relationship subtly", description: "The wearer should lead, with the relationship quietly influencing part of the design.", target: { L: 60, V: 80, D: 80 } },
          { id: "visible", label: "Give equal weight to the wearer’s personal style and what the relationship means", description: "The wearer’s personal style and what the relationship means should be equally important in shaping the ring’s direction.", target: { L: 100, T: 70, A: 40, H: 45 } }
      ]
    },
    {
      id: "relationship",
      kicker: "The relationship",
      title: "Which description is closest to what the relationship feels built upon?",
      help: "Choose what is true, not what sounds most romantic.",
      type: "single",
      options: [
        { id: "steadiness", label: "Steadiness and endurance", target: { L: 40, G: 65, M: 10, A: 0 } },
        { id: "independence", label: "Two independent people repeatedly choosing one another", target: { L: 100, T: 100, A: 75 } },
        { id: "lightness", label: "Lightness, optimism and celebration", target: { L: 60, P: 80, M: 80, C: 50 } },
        { id: "intimacy", label: "Protection, intimacy and being held", target: { L: 80, H: 90, V: 100, P: 45 } },
        { id: "change", label: "Change, adventure and continuing movement", target: { L: 70, O: 85, M: 100, A: 60 } },
        { id: "private", label: "Something private that does not need explaining", target: { L: 50, V: 100, D: 100, P: 35 } }
      ]
    },
    {
      id: "avoid",
      kicker: "The negative constraint",
      title: "What must the finished ring never feel like?",
      help: "Choose one or two. A useful design brief is partly defined by what it refuses.",
      type: "multi",
      max: 2,
      options: [
        { id: "conventional", label: "Too conventional or expected", avoid: { O: 10, A: 0, G: 20, P: 45 } },
        { id: "showy", label: "Too showy or high-impact", avoid: { P: 100, H: 90, V: 0, S: 80 } },
        { id: "ornate", label: "Too soft, ornate or romantic", avoid: { G: 10, H: 100, S: 80, M: 60 } },
        { id: "hard", label: "Too hard or geometric", avoid: { G: 100, M: 0, A: 0 } },
        { id: "literal", label: "Too literal or obviously symbolic", avoid: { T: 100, L: 100 } },
        { id: "plain", label: "Too plain or minimal", avoid: { P: 25, H: 0, S: 0, O: 10 } },
        { id: "open", label: "Nothing here. Keep the direction open.", open: true }
      ]
    }
  ];

  var practicalStep = {
    id: "practical",
    kicker: "The practical context",
    title: "A few practical details before your brief.",
    help: "How it will be worn, the investment range and timing help keep the next step realistic. They do not determine the design.",
    type: "practical"
  };

  var collections = [
    {
      id: "cannele", name: "Cannelé", P: 50, D: 75, V: 55, O: 35, C: 30, A: 0, M: 20, H: 85, S: 100, T: 0, L: 25, G: 25, Z: 60,
      url: "https://andrewgeoghegan.com/collections/cannele",
      image: "https://andrewgeoghegan.com/cdn/shop/files/cannele-diamond-682867.jpg?v=1731364962&width=823",
      summary: "Classical discipline, fluting and craftsmanship that reveals itself gradually.",
      options: "The current Cannelé family includes platinum, yellow gold and rose gold, several centre stone sizes, and established diamond, sapphire, ruby and chocolate-diamond variations.",
      adaptable: true
    },
    {
      id: "cannele-twist", name: "Cannelé Twist", P: 60, D: 70, V: 45, O: 50, C: 40, A: 30, M: 90, H: 85, S: 80, T: 0, L: 30, G: 20, Z: 70,
      url: "https://andrewgeoghegan.com/collections/cannele-twist",
      image: "https://andrewgeoghegan.com/cdn/shop/files/cannele-twist-diamond-350351.jpg?v=1723266150&width=823",
        summary: "A familiar halo arrangement given rotational movement and a distinctive rising profile.",
      options: "The current Cannelé Twist family includes platinum, yellow gold and rose gold, selected centre stone sizes, and established diamond, oval-diamond, sapphire and chocolate-diamond variations."
    },
    {
      id: "asteria", name: "Asteria", P: 70, D: 35, V: 20, O: 55, C: 50, A: 5, M: 55, H: 90, S: 30, T: 0, L: 35, G: 35, Z: 75,
      url: "https://andrewgeoghegan.com/collections/asteria",
      image: "https://andrewgeoghegan.com/cdn/shop/files/asteria-diamond-solitaire-246234.jpg?v=1723632952&width=823",
      summary: "Outward radiance, light and a centred halo with energy from every angle.",
      options: "The current Asteria family includes platinum, yellow gold and rose gold, selected centre stone sizes, and established diamond, tsavorite, sapphire and ruby variations."
    },
    {
      id: "satellite", name: "Satellite", P: 75, D: 30, V: 20, O: 85, C: 80, A: 100, M: 75, H: 20, S: 10, T: 100, L: 100, G: 45, Z: 60,
      url: "https://andrewgeoghegan.com/collections/satellite",
      image: "https://andrewgeoghegan.com/cdn/shop/files/satellite-diamond-546459.jpg?v=1734100171&width=823",
      summary: "Two independent stones held in a dynamic, asymmetric relationship.",
      options: "The current Satellite family includes platinum, yellow gold and rose gold, selected centre stone sizes, and established diamond, sapphire and ruby variations.",
      adaptable: true
    },
    {
      id: "infinity", name: "Infinity", P: 60, D: 55, V: 50, O: 100, C: 65, A: 75, M: 30, H: 55, S: 30, T: 100, L: 100, G: 20, Z: 70,
      url: "https://andrewgeoghegan.com/pages/contact",
      image: "./image-catalogue-batch-03/infinity-aquamarine.jpg",
      summary: "A flowing two-stone composition with movement, light and a generous sense of connection.",
      options: "Infinity can be made in platinum, yellow gold or rose gold, with diamond or coloured centre stones. It may be suggested even when it is not currently listed online.",
      adaptable: true,
      availableOnline: false
    },
    {
      id: "chapiteau", name: "Chapiteau", P: 95, D: 15, V: 10, O: 80, C: 80, A: 0, M: 15, H: 75, S: 50, T: 0, L: 20, G: 100, Z: 95,
      url: "https://andrewgeoghegan.com/collections/chapiteau",
      image: "https://andrewgeoghegan.com/cdn/shop/files/chapiteau-de-diamants-677446.jpg?v=1725972683&width=823",
      summary: "Architecture, hexagonal geometry, height and unapologetic spectacle.",
      options: "The current Chapiteau family includes platinum, yellow gold and rose gold, selected centre stone sizes, and established diamond, sapphire, ruby, chocolate-diamond and Paraiba variations."
    },
    {
      id: "clair-de-lune", name: "Clair de Lune", P: 80, D: 55, V: 25, O: 65, C: 75, A: 20, M: 65, H: 100, S: 45, T: 0, L: 45, G: 20, Z: 80,
      url: "https://andrewgeoghegan.com/collections/clair-de-lune",
      image: "https://andrewgeoghegan.com/cdn/shop/files/clair-de-lune-diamond-ring-335150.jpg?v=1725972849&width=823",
      summary: "Romantic movement, colour and layered halo depth with a sense of moonlit light.",
      options: "The current Clair de Lune family includes platinum, yellow gold and rose gold, selected centre stone sizes, and established Diamond, Azure, Roux and Doré variations."
    },
    {
      id: "embrace", name: "Embrace", P: 40, D: 100, V: 100, O: 45, C: 15, A: 0, M: 25, H: 0, S: 20, T: 0, L: 55, G: 25, Z: 55,
      url: "https://andrewgeoghegan.com/collections/embrace",
      image: "https://andrewgeoghegan.com/cdn/shop/files/embrace-923780.jpg?v=1731365576&width=823",
      summary: "A clean outward reading with its diamond river held mainly for the wearer.",
      options: "The current Embrace family includes platinum, yellow gold and rose gold, with established centre stone sizes."
    },
    {
      id: "emergence", name: "Emergence", P: 70, D: 75, V: 70, O: 95, C: 45, A: 60, M: 100, H: 15, S: 20, T: 25, L: 70, G: 45, Z: 65,
      url: "https://andrewgeoghegan.com/collections/emergence",
      image: "https://andrewgeoghegan.com/cdn/shop/files/emergence-flow-diamond-solitaire-403027.jpg?v=1728631057&width=823",
        summary: "A flowing form with vertical movement and an unconventional figure-eight line.",
      options: "The current Emergence family includes platinum, yellow gold and rose gold, with established solitaire, pavé Flow and plain Flow variations."
    },
    {
      id: "empress", name: "Empress", P: 85, D: 20, V: 15, O: 55, C: 10, A: 0, M: 10, H: 45, S: 35, T: 0, L: 25, G: 100, Z: 90,
      url: "https://andrewgeoghegan.com/collections/empress",
      image: "https://andrewgeoghegan.com/cdn/shop/files/empress-diamond-695549.jpg?v=1731365573&width=823",
      summary: "Composure, square geometry and strong physical presence.",
      options: "The current Empress family includes platinum, yellow gold and rose gold, with established diamond and aquamarine variations."
    },
    {
      id: "lacuna", name: "Lacuna", P: 55, D: 100, V: 75, O: 70, C: 20, A: 0, M: 15, H: 100, S: 10, T: 0, L: 35, G: 30, Z: 60,
      url: "https://andrewgeoghegan.com/collections/lacuna",
      image: "https://andrewgeoghegan.com/cdn/shop/files/lacuna-851316.jpg?v=1728631118&width=823",
      summary: "Shadow, negative space and a halo whose tension is discovered gradually.",
      options: "The current Lacuna family includes platinum, yellow gold and rose gold, with established centre stone sizes.",
      adaptable: true
    },
    {
      id: "theia", name: "Theia", P: 85, D: 35, V: 20, O: 80, C: 70, A: 20, M: 45, H: 100, S: 25, T: 100, L: 100, G: 35, Z: 80,
      url: "https://andrewgeoghegan.com/collections/theia",
      image: "https://andrewgeoghegan.com/cdn/shop/files/theia-diamond-184396.jpg?v=1734100513&width=1600",
      summary: "Two stones held within one shared field of light.",
      options: "The current Theia family includes platinum, yellow gold and rose gold, with established centre stone sizes."
    }
  ];

  var elements = {
    intro: document.getElementById("intro"),
    proof: document.querySelector(".proof-strip"),
    quiz: document.getElementById("quiz"),
    result: document.getElementById("result"),
    stage: document.getElementById("question-stage"),
    contactStage: document.getElementById("contact-stage"),
    stepCount: document.getElementById("step-count"),
    stepTime: document.getElementById("step-time"),
    progress: document.getElementById("progress-bar"),
    kicker: document.getElementById("question-kicker"),
    title: document.getElementById("question-title"),
    help: document.getElementById("question-help"),
    answers: document.getElementById("answers"),
    questionError: document.getElementById("question-error"),
    back: document.getElementById("back-button"),
    next: document.getElementById("next-button"),
    form: document.getElementById("contact-form"),
    contactError: document.getElementById("contact-error")
  };

  function visualMarkup(key) {
    var open = '<svg viewBox="0 0 180 120" role="img" aria-hidden="true">';
    var close = "</svg>";
    var map = {
      "presence-quiet": '<circle class="line fine" cx="90" cy="60" r="13"/><rect class="line fine" x="42" y="58" width="35" height="4" rx="2"/><rect class="line fine" x="103" y="58" width="35" height="4" rx="2"/>',
      "presence-assured": '<circle class="line" cx="90" cy="60" r="16"/><rect class="line fine" x="39" y="57.8" width="35" height="4.4" rx="2.2"/><rect class="line fine" x="106" y="57.8" width="35" height="4.4" rx="2.2"/>',
      "presence-expressive": '<circle class="line" cx="90" cy="60" r="19"/><rect class="line fine" x="36" y="57.58" width="35" height="4.84" rx="2.42"/><rect class="line fine" x="109" y="57.58" width="35" height="4.84" rx="2.42"/>',
      "presence-unmistakable": '<circle class="line" cx="90" cy="60" r="22" style="stroke-width:2.4"/><rect class="line fine" x="33" y="57.338" width="35" height="5.324" rx="2.662"/><rect class="line fine" x="112" y="57.338" width="35" height="5.324" rx="2.662"/>',
      "form-classical": '<circle class="line" cx="90" cy="53" r="24"/><path class="line fine" d="M42 76 Q66 88 90 88 Q114 88 138 76"/><circle class="line fine" cx="58" cy="72" r="6"/><circle class="line fine" cx="122" cy="72" r="6"/>',
      "form-departure": '<circle class="line" cx="82" cy="54" r="25"/><circle class="fill" cx="119" cy="72" r="7"/>',
      "form-architectural": '<polygon class="line" points="90,22 126,42 126,82 90,102 54,82 54,42"/><rect class="line fine" x="73" y="45" width="34" height="34"/>',
      "form-asymmetric": '<circle class="line" cx="69" cy="70" r="23"/><circle class="line" cx="116" cy="45" r="13"/><path class="line fine" d="M47 87 Q92 110 134 57"/>',
      "form-flowing": '<path class="line" d="M90 18 C41 38 45 78 90 102 C135 78 139 38 90 18 Z"/><path class="line fine" d="M90 18 C128 38 124 78 90 102 C56 78 52 38 90 18 Z"/>',
      "colour-white": '<circle cx="90" cy="60" r="32" fill="#fff" stroke="#898989"/><path class="line fine" d="M90 28 L90 92 M58 60 L122 60 M67 37 L113 83 M113 37 L67 83"/>',
      "colour-accent": '<circle cx="90" cy="60" r="32" fill="#fff" stroke="#898989"/><circle cx="111" cy="78" r="8" fill="#6f8577"/>',
      "colour-centre": '<circle cx="90" cy="60" r="34" fill="#5d7469" stroke="#2f3e36"/><circle cx="80" cy="49" r="8" fill="rgba(255,255,255,.28)"/>',
      "colour-dialogue": '<circle cx="72" cy="65" r="27" fill="#597568" stroke="#2f3e36"/><circle cx="113" cy="50" r="18" fill="#9b7287" stroke="#5d3e50"/>',
      "colour-open": '<circle class="line fine" cx="78" cy="60" r="26"/><circle class="line fine" cx="102" cy="60" r="26"/><path class="line" d="M58 60 H122"/>',
      "symbol-form": '<path class="line" d="M51 78 Q90 22 129 78"/><line class="line fine" x1="51" y1="78" x2="129" y2="78"/>',
      "symbol-one": '<circle class="line" cx="90" cy="60" r="28"/><circle class="fill" cx="90" cy="60" r="5"/>',
      "symbol-independent": '<circle class="line" cx="65" cy="70" r="22"/><circle class="line" cx="116" cy="47" r="16"/>',
      "symbol-shared": '<circle class="line" cx="76" cy="60" r="20"/><circle class="line" cx="104" cy="60" r="20"/><ellipse class="line fine" cx="90" cy="60" rx="49" ry="35"/>',
      "symbol-protective": '<circle class="line" cx="90" cy="60" r="38"/><circle class="line fine" cx="90" cy="60" r="12"/><path class="line fine" d="M61 84 Q90 105 119 84"/>',
      "symbol-private": '<path class="line" d="M48 48 Q90 19 132 48"/><path class="line fine" d="M48 70 Q90 96 132 70"/><circle class="fill" cx="90" cy="76" r="4"/>'
    };
    return open + (map[key] || map["symbol-form"]) + close;
  }

  function getQuestion(id) {
    return questions.find(function (question) { return question.id === id; });
  }

  function getOption(questionId, optionId) {
    var question = getQuestion(questionId);
    if (!question) return null;
    return question.options.find(function (option) { return option.id === optionId; }) || null;
  }

  function isSelfWearerOnly(answers) {
    return answers.evidence === "wearer" && answers.subject === "wearer";
  }

  function isSoloPartnerChooser(answers) {
    return ["direct", "observed", "confident", "limited"].indexOf(answers.evidence) !== -1;
  }

  function relationshipMeaningRelevant(answers) {
    return !isSelfWearerOnly(answers) && !(answers.subject === "wearer" && answers.symbolism === "form");
  }

  function normaliseConditionalAnswers(answers) {
    var normalised = Object.assign({}, answers || {});
    if (isSelfWearerOnly(normalised)) {
      delete normalised.symbolism;
      delete normalised.relationship;
    } else if (normalised.subject === "wearer" && normalised.symbolism === "form") {
      delete normalised.relationship;
    }
    return normalised;
  }

  function activeQuestions(answers) {
    answers = answers || state.answers;
    return questions.filter(function (question) {
      if (
        isSelfWearerOnly(answers) &&
        (question.id === "symbolism" || question.id === "relationship")
      ) {
        return false;
      }
      if (
        question.id === "relationship" &&
        answers.subject === "wearer" &&
        answers.symbolism === "form"
      ) {
        return false;
      }
      return true;
    });
  }

  function pruneConditionalAnswers() {
    state.answers = normaliseConditionalAnswers(state.answers);
    if (!isSoloPartnerChooser(state.answers)) delete state.practical.wearerApproval;
  }

  function answerText(questionId) {
    var question = getQuestion(questionId);
    var value = state.answers[questionId];
    if (!question || value == null) return "";
    if (Array.isArray(value)) {
      return value.map(function (id) {
        var option = getOption(questionId, id);
        return option ? option.label : id;
      }).join("; ");
    }
    var option = getOption(questionId, value);
    return option ? option.label : value;
  }

  function renderPractical() {
    var wearerApprovalField = isSoloPartnerChooser(state.answers)
      ? '<div class="field-group"><label for="wearer-approval">Will the wearer approve the finished ring before the proposal?</label><select id="wearer-approval">' +
        '<option value="">Choose one</option><option value="together">Yes, we will confirm it together</option>' +
        '<option value="surprise">No, the finished ring needs to remain a surprise</option>' +
        '<option value="not-proposal">This ring is not for a proposal</option>' +
        '<option value="unknown">I am not sure yet</option></select>' +
        '<p class="field-note">This does not change the design direction. It helps Andrew protect the proposal from an over-confident final choice.</p></div>'
      : "";
    elements.answers.className = "practical-grid";
    elements.answers.innerHTML =
      '<div class="field-group"><label for="wear-pattern">How will the ring be worn?</label><select id="wear-pattern">' +
      '<option value="">Choose one</option><option value="active">Every day, including an active or hands-on life</option>' +
      '<option value="careful">Every day, but removed for rough work</option>' +
      '<option value="occasion">Mainly for selected occasions</option><option value="unknown">Not sure yet</option></select></div>' +
      '<div class="field-group"><label for="budget-band">Which investment range feels comfortable for the complete ring?</label><select id="budget-band">' +
      '<option value="">Choose a range</option><option value="up-to-3">Up to £3,000</option><option value="3-5">£3,000 to £5,000</option>' +
      '<option value="5-8">£5,000 to £8,000</option><option value="8-plus">£8,000+</option>' +
      '<option value="unknown">Still exploring</option></select><p class="field-note">Stone and finished ring together. This does not change your design direction; current website prices are checked when your private brief opens.</p></div>' +
      '<div class="field-group"><label for="timing-band">When is the ring needed?</label><select id="timing-band">' +
      '<option value="">Choose one</option><option value="under-6">Within 6 weeks</option><option value="6-12">In 6 to 12 weeks</option>' +
      '<option value="3-6">In 3 to 6 months</option><option value="6-plus">More than 6 months away</option><option value="open">No fixed date</option></select></div>' +
      wearerApprovalField +
      '<div class="field-group"><label for="stone-preference">Current stone instinct</label><select id="stone-preference">' +
      '<option value="open">Keep it open</option><option value="natural-diamond">Natural diamond</option><option value="lab-diamond">Lab-grown diamond</option>' +
      '<option value="coloured">Coloured gemstone</option><option value="existing">I already have one stone to discuss</option></select></div>' +
      '<div class="field-group optional-consideration"><p class="optional-consideration-heading">One final design consideration (optional)</p>' +
      '<label class="optional-consideration-choice" for="extended-setting-arrangement"><input id="extended-setting-arrangement" type="checkbox">' +
      '<span>I would also consider a design in which the main settings extend beyond just the top central area of the ring.</span></label>' +
      '<p class="field-note">For example, a three-stone composition spreading across the top of the finger, or a half- or fully set style with detail continuing further around the ring.</p></div>' +
      '<p class="selection-note">No price, lead time or stone availability is promised by this brief. Andrew confirms those against the actual piece.</p>';

    var fields = {
      wear: document.getElementById("wear-pattern"),
      budget: document.getElementById("budget-band"),
      timing: document.getElementById("timing-band"),
      stone: document.getElementById("stone-preference")
    };
    if (isSoloPartnerChooser(state.answers)) {
      fields.wearerApproval = document.getElementById("wearer-approval");
    }
    if (!state.practical.stone) state.practical.stone = fields.stone.value;
    Object.keys(fields).forEach(function (key) {
      if (state.practical[key]) fields[key].value = state.practical[key];
      fields[key].addEventListener("change", function (event) {
        state.practical[key] = event.target.value;
        updateNextState();
      });
    });
    var extendedSettingArrangement = document.getElementById("extended-setting-arrangement");
    extendedSettingArrangement.checked = !!state.practical.extendedSettingArrangement;
    extendedSettingArrangement.addEventListener("change", function (event) {
      state.practical.extendedSettingArrangement = !!event.target.checked;
    });
  }

  function updateProgressDisplay() {
    var total = activeQuestions(state.answers).length + 1;
    var remaining = Math.max(total - state.current, 1);
    var minutesRemaining = Math.max(1, Math.ceil(3 * remaining / total));
    elements.stepCount.textContent = String(state.current + 1).padStart(2, "0") + " / " + String(total).padStart(2, "0");
    elements.stepTime.textContent = "About " + minutesRemaining + " minute" + (minutesRemaining === 1 ? "" : "s");
    elements.progress.style.width = ((state.current + 1) / total * 100) + "%";
  }

  function renderQuestion() {
    var visibleQuestions = activeQuestions(state.answers);
    var step = state.current < visibleQuestions.length ? visibleQuestions[state.current] : practicalStep;
    elements.contactStage.hidden = true;
    elements.stage.hidden = false;
    elements.questionError.hidden = true;
    elements.kicker.textContent = step.kicker;
    elements.title.textContent = step.title;
    elements.help.textContent = step.help;
    updateProgressDisplay();
    elements.back.style.visibility = state.current === 0 ? "hidden" : "visible";
    elements.back.tabIndex = state.current === 0 ? -1 : 0;

    if (step.type === "practical") {
      elements.answers.removeAttribute("role");
      elements.answers.removeAttribute("aria-labelledby");
      renderPractical();
      updateNextState();
      window.scrollTo({ top: elements.quiz.offsetTop, behavior: "smooth" });
      setTimeout(function () {
        elements.title.setAttribute("tabindex", "-1");
        elements.title.focus({ preventScroll: true });
      }, 250);
      return;
    }

    var className = "answers";
    if (step.layout === "visual") className += " visual-grid";
    if (step.layout === "visual-three") className += " visual-grid visual-three";
    if (step.layout === "visual-five") className += " visual-grid visual-five";
    elements.answers.className = className;
    elements.answers.innerHTML = "";
    elements.answers.setAttribute("role", step.type === "multi" ? "group" : "radiogroup");
    elements.answers.setAttribute("aria-labelledby", "question-title");

    step.options.forEach(function (option) {
      if (option.groupBefore) {
        var groupHeading = document.createElement("p");
        groupHeading.className = "answer-group-heading";
        groupHeading.textContent = option.groupBefore;
        elements.answers.appendChild(groupHeading);
      }
      var button = document.createElement("button");
      var selectedValue = state.answers[step.id];
      var selected = step.type === "multi" ? (selectedValue || []).indexOf(option.id) !== -1 : selectedValue === option.id;
      button.type = "button";
      var hasVisual = !!(option.visual || option.asset || option.image || option.images);
      button.className = "answer" + (hasVisual ? " visual-choice" : "") + (step.type === "multi" ? " multi-choice" : "") + " question-" + step.id;
      if (option.asset) button.className += " asset-choice-" + option.asset;
      if (step.type === "multi") {
        button.setAttribute("aria-pressed", selected ? "true" : "false");
      } else {
        button.setAttribute("role", "radio");
        button.setAttribute("aria-checked", selected ? "true" : "false");
      }
      button.dataset.value = option.id;
      if (step.type === "multi") button.dataset.multi = "true";

      if (hasVisual) {
        var visual = document.createElement("span");
        visual.className = "answer-visual";
        if (option.asset) {
          var suppliedAsset = assetUrl(option.asset);
          visual.className += " answer-photo answer-photo-" + option.asset;
          if (suppliedAsset) {
            if (option.asset === "chairs") {
              var chairSlice = document.createElement("span");
              chairSlice.className = "chair-slice";
              chairSlice.style.backgroundImage = 'url("' + suppliedAsset + '")';
              chairSlice.style.setProperty("--asset-position", option.assetPosition || "0%");
              visual.appendChild(chairSlice);
            } else {
              visual.style.backgroundImage = 'url("' + suppliedAsset + '")';
              visual.style.setProperty("--asset-position", option.assetPosition || "0%");
            }
            visual.setAttribute("role", "img");
            visual.setAttribute("aria-label", option.label + " visual study");
          } else {
            visual.className += " asset-placeholder";
            visual.innerHTML = visualMarkup((option.asset === "chairs" ? "form-" : "colour-") + (option.id === "talismanic" ? "flowing" : option.id));
          }
        } else if (option.image) {
          var imageUrl = assetUrl(option.image);
          if (imageUrl) {
            var image = document.createElement("img");
            image.src = imageUrl;
            image.alt = option.label + " metal direction";
            visual.appendChild(image);
          } else {
            visual.className += " asset-placeholder";
            visual.innerHTML = visualMarkup("colour-" + option.id);
          }
        } else if (option.images) {
          var suppliedImages = option.images.map(assetUrl).filter(Boolean);
          visual.className += " answer-image-group images-" + Math.max(suppliedImages.length, 1);
          if (suppliedImages.length) {
            suppliedImages.forEach(function (src) {
              var groupImage = document.createElement("img");
              groupImage.src = src;
              groupImage.alt = "";
              visual.appendChild(groupImage);
            });
          } else {
            visual.className += " asset-placeholder";
            visual.innerHTML = visualMarkup("colour-open");
          }
        } else {
          visual.innerHTML = visualMarkup(option.visual);
        }
        button.appendChild(visual);

        var copy = document.createElement("span");
        copy.className = "visual-choice-copy";
        var title = document.createElement("span");
        title.className = "visual-answer-title";
        title.textContent = option.label;
        copy.appendChild(title);
        if (option.description) {
          var note = document.createElement("span");
          note.className = "visual-answer-note";
          note.textContent = option.description;
          copy.appendChild(note);
        }
        button.appendChild(copy);
      } else {
        var content = document.createElement("span");
        content.className = "answer-content";
        var label = document.createElement("span");
        label.className = "answer-label";
        label.textContent = option.label;
        content.appendChild(label);
        if (option.description) {
          var description = document.createElement("span");
          description.className = "answer-description";
          description.textContent = option.description;
          content.appendChild(description);
        }
        button.appendChild(content);
      }

      var mark = document.createElement("span");
      mark.className = "answer-mark";
      mark.setAttribute("aria-hidden", "true");
      button.appendChild(mark);
      button.addEventListener("click", function () { selectAnswer(step, option.id); });
      elements.answers.appendChild(button);
    });

    if (step.type === "multi") {
      var note = document.createElement("p");
      note.className = "selection-note";
      note.textContent = "Select up to two.";
      elements.answers.appendChild(note);
    }

    if (step.note) {
      var guidance = document.createElement("p");
      guidance.className = "selection-note question-guidance";
      guidance.textContent = step.note;
      elements.answers.appendChild(guidance);
    }

    updateNextState();
    window.scrollTo({ top: elements.quiz.offsetTop, behavior: "smooth" });
    setTimeout(function () {
      elements.title.setAttribute("tabindex", "-1");
      elements.title.focus({ preventScroll: true });
    }, 250);
  }

  function selectAnswer(step, optionId) {
    elements.questionError.hidden = true;
    if (step.type === "multi") {
      var selected = Array.isArray(state.answers[step.id]) ? state.answers[step.id].slice() : [];
      if (optionId === "open") {
        selected = ["open"];
      } else {
        selected = selected.filter(function (id) { return id !== "open"; });
        var existing = selected.indexOf(optionId);
        if (existing !== -1) {
          selected.splice(existing, 1);
        } else if (selected.length < step.max) {
          selected.push(optionId);
        } else {
          elements.questionError.textContent = "Choose no more than two.";
          elements.questionError.hidden = false;
          return;
        }
      }
      state.answers[step.id] = selected;
    } else {
      state.answers[step.id] = optionId;
    }
    pruneConditionalAnswers();
    updateProgressDisplay();
    elements.answers.querySelectorAll("button[data-value]").forEach(function (button) {
      var value = button.dataset.value;
      var isSelected = step.type === "multi"
        ? state.answers[step.id].indexOf(value) !== -1
        : state.answers[step.id] === value;
      button.setAttribute(step.type === "multi" ? "aria-pressed" : "aria-checked", isSelected ? "true" : "false");
    });
    updateNextState();
  }

  function updateNextState() {
    var visibleQuestions = activeQuestions(state.answers);
    if (state.current === visibleQuestions.length) {
      var practicalComplete = state.practical.wear && state.practical.budget && state.practical.timing;
      if (isSoloPartnerChooser(state.answers)) practicalComplete = practicalComplete && state.practical.wearerApproval;
      elements.next.disabled = !practicalComplete;
      return;
    }
    var step = visibleQuestions[state.current];
    var value = state.answers[step.id];
    elements.next.disabled = step.type === "multi" ? !Array.isArray(value) || value.length === 0 : !value;
  }

  function showContact() {
    elements.stage.hidden = true;
    elements.contactStage.hidden = false;
    elements.stepCount.textContent = "Brief ready";
    elements.progress.style.width = "100%";
    elements.back.style.visibility = "visible";
    elements.back.tabIndex = 0;
    elements.contactStage.scrollIntoView({ behavior: "smooth", block: "start" });
    setTimeout(function () { document.getElementById("first-name").focus({ preventScroll: true }); }, 400);
  }

  function showDeliveryConfirmation(contact) {
    elements.stage.hidden = true;
    elements.contactStage.hidden = false;
    elements.back.style.visibility = "hidden";
    elements.back.tabIndex = -1;
    elements.contactStage.innerHTML = "";
    var wrapper = document.createElement("div");
    wrapper.className = "contact-copy";
    var eyebrow = document.createElement("p");
    eyebrow.className = "section-kicker";
    eyebrow.textContent = "Your Ring Design Brief";
    var heading = document.createElement("h2");
    heading.textContent = "It is on its way.";
    var copy = document.createElement("p");
    copy.className = "contact-value";
    copy.textContent = (contact.firstName ? contact.firstName + ", y" : "Y") + "our personalised Ring Design Brief has been sent to " + contact.email + ". Please check your inbox, and your spam or promotions folder if it does not arrive shortly.";
    wrapper.appendChild(eyebrow);
    wrapper.appendChild(heading);
    wrapper.appendChild(copy);
    elements.contactStage.appendChild(wrapper);
    elements.contactStage.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function mean(values) {
    if (!values.length) return 0;
    return values.reduce(function (sum, value) { return sum + value; }, 0) / values.length;
  }

  function positiveFit(collection, target) {
    if (!target) return 50;
    var keys = Object.keys(target);
    if (!keys.length) return 50;
    return 100 - mean(keys.map(function (key) { return Math.abs(collection[key] - target[key]); }));
  }

  function avoidFit(collection, selectedIds) {
    if (!Array.isArray(selectedIds) || !selectedIds.length || selectedIds.indexOf("open") !== -1) return 50;
    var fits = selectedIds.map(function (id) {
      var option = getOption("avoid", id);
      if (!option || !option.avoid) return 50;
      var keys = Object.keys(option.avoid);
      return mean(keys.map(function (key) { return Math.abs(collection[key] - option.avoid[key]); }));
    });
    var lowestFit = Math.min.apply(null, fits);
    return lowestFit * 0.70 + mean(fits) * 0.30;
  }

  function questionFit(questionId, collection, answers) {
    var question = getQuestion(questionId);
    var value = answers[questionId];
    if (!question || value == null) return 50;
    if (questionId === "avoid") {
      // A classical foundation that must not feel conventional is a coherent
      // request for one distinctive feature, not two answers that cancel out.
      if (answers.originality === "classical" && Array.isArray(value) && value.indexOf("conventional") !== -1) {
        var distinctive = getOption("originality", "departure");
        var distinctiveFit = positiveFit(collection, distinctive && distinctive.target);
        var remainingAvoids = value.filter(function (id) { return id !== "conventional"; });
        if (!remainingAvoids.length) return distinctiveFit;
        var remainingFit = avoidFit(collection, remainingAvoids);
        return Math.min(distinctiveFit, remainingFit) * 0.70 + mean([distinctiveFit, remainingFit]) * 0.30;
      }
      return avoidFit(collection, value);
    }
    if (questionId === "wholeRing") {
      var collectionFits = wholeRingFitByCollection[collection.id];
      return collectionFits && Number.isFinite(collectionFits[value]) ? collectionFits[value] : 50;
    }
    var option = getOption(questionId, value);
    if (!option || option.open) return 50;
    return positiveFit(collection, option.target);
  }

  function evidenceFactor(answers) {
    var option = getOption("evidence", answers.evidence);
    return option && option.factor ? option.factor : 0.55;
  }

  function practicalPenalty(collection, practical) {
    if (practical.wear === "active") {
      if (collection.Z >= 80) return -12;
      if (collection.Z >= 65) return -6;
    }
    if (practical.wear === "careful" && collection.Z >= 90) return -6;
    return 0;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function scoreCollection(collection, answers, practical) {
    var wearerComponents = [
      { id: "presence", weight: 0.21 },
      { id: "wholeRing", weight: 0.22 },
      { id: "originality", weight: 0.24 },
      { id: "colour", weight: 0.18 },
      { id: "avoid", weight: 0.15 }
    ];
    var activeComponents = wearerComponents.filter(function (component) {
      var value = answers[component.id];
      if (component.id === "avoid") return Array.isArray(value) && value.length && value.indexOf("open") === -1;
      var option = getOption(component.id, value);
      return !!(option && !option.open);
    });
    var activeWeight = activeComponents.reduce(function (sum, component) { return sum + component.weight; }, 0);
    var wearer = activeWeight
      ? activeComponents.reduce(function (sum, component) {
          return sum + questionFit(component.id, collection, answers) * component.weight;
        }, 0) / activeWeight
      : 50;

    var subject = answers.subject || "balance";
    var relationshipRelevant = relationshipMeaningRelevant(answers);
    var relationship = relationshipRelevant
      ? questionFit("symbolism", collection, answers) * 0.35 +
        questionFit("relationship", collection, answers) * 0.65
      : null;

    var weights = subjectWeights[subject] || subjectWeights.balance;
    var expression = !relationshipRelevant
      ? wearer
      : wearer * weights.wearer + relationship * weights.relationship;
    var penalty = practicalPenalty(collection, practical);
    return {
      collection: collection,
      wearerScore: wearer,
      relationshipScore: relationship,
      relationshipRelevant: relationshipRelevant,
      expressionScore: expression,
      practicalPenalty: penalty,
      finalScore: clamp(expression + penalty, 0, 100),
      wearerEligible: wearer >= 55
    };
  }

  function confidenceScore(answers, practical, contact) {
    var score = evidenceFactor(answers);
    ["colour"].forEach(function (id) {
      var option = getOption(id, answers[id]);
      if (option && option.open) score -= 0.08;
    });
    if (Array.isArray(answers.avoid) && answers.avoid.indexOf("open") !== -1) score -= 0.08;
    if (practical.wear === "unknown") score -= 0.05;
    return clamp(score, 0.45, 1);
  }

  function designDirectionFromAnswers(answers, practical) {
    answers = normaliseConditionalAnswers(answers);
    var unresolved = [];
    if (answers.colour === "open") unresolved.push("colour");
    if (answers.metal === "open") unresolved.push("metal");
    if (Array.isArray(answers.avoid) && answers.avoid.indexOf("open") !== -1) unresolved.push("negative constraints");
    if (!practical.stone || practical.stone === "open") unresolved.push("stone type");
    if (!practical.wear || practical.wear === "unknown") unresolved.push("wear pattern");

    return {
      focus: answers.subject || "balance",
      chooserMode: answers.evidence || "limited",
      presence: answers.presence || null,
      wholeRingQuality: answers.wholeRing || null,
      originality: answers.originality || null,
      colourRole: answers.colour || "open",
      metalDirection: answers.metal || "open",
      relationshipRelevant: relationshipMeaningRelevant(answers),
      relationshipExpression: relationshipMeaningRelevant(answers) ? answers.symbolism || null : "not-applicable",
      relationshipQuality: relationshipMeaningRelevant(answers) ? answers.relationship || null : "not-applicable",
      exclusions: Array.isArray(answers.avoid) ? answers.avoid.filter(function (id) { return id !== "open"; }) : [],
      unresolved: unresolved
    };
  }

  function detectConflicts(answers, practical) {
    answers = normaliseConditionalAnswers(answers);
    practical = practical || {};
    var avoid = Array.isArray(answers.avoid) ? answers.avoid : [];
    var conflicts = [];

    function add(id, severity, penalty, explanation, consequence) {
      conflicts.push({
        id: id,
        severity: severity,
        penalty: penalty,
        explanation: explanation,
        consequence: consequence
      });
    }

    if (answers.presence === "unmistakable" && avoid.indexOf("showy") !== -1) {
      add(
        "presence-without-spectacle",
        "major-tension",
        0.175,
        "The ring should have unmistakable presence but must never feel showy or high-impact.",
        "Andrew needs to establish whether presence should come from form, detail or scale before a ring is named."
      );
    }
    // "Classical" plus "not conventional" is handled in questionFit as a
    // classical foundation with one distinctive feature. It is not a conflict.
    if (answers.subject === "wearer" && answers.symbolism === "visible") {
      add(
        "focus-weight-conflict",
        "blocking",
        0.30,
        "The wearer was asked to lead, while a later answer gives equal visual weight to the relationship.",
        "The primary design subject must be clarified before collection or bespoke is stated."
      );
    }
    if (answers.subject === "relationship" && answers.symbolism === "form") {
      add(
        "relationship-expression-conflict",
        "blocking",
        0.30,
        "The relationship was asked to lead, while a later answer says it need not influence how the ring looks.",
        "The role of relationship meaning must be clarified before a design route is stated."
      );
    }
    if (answers.colour === "white" && practical.stone === "coloured") {
      add(
        "stone-colour-conflict",
        "blocking",
        0.25,
        "White light was chosen to lead, while the current stone instinct is a coloured gemstone.",
        "Stone and colour direction should be clarified before a collection is presented as the answer."
      );
    }
    if (answers.originality === "architectural" && avoid.indexOf("hard") !== -1) {
      add(
        "geometry-without-hardness",
        "productive-tension",
        0.08,
        "The ring should feel architectural but not hard or geometric.",
        "Precision may need to be softened through proportion, transition or line."
      );
    }
    if (answers.symbolism === "visible" && avoid.indexOf("literal") !== -1) {
      add(
        "meaning-without-literal-symbolism",
        "productive-tension",
        0.08,
        "The relationship should influence the ring clearly but must not become an obvious symbol.",
        "Meaning should be carried through the relationship between elements rather than a literal motif."
      );
    }
    if (answers.wholeRing === "restraint" && avoid.indexOf("plain") !== -1) {
      add(
        "restraint-with-detail",
        "productive-tension",
        0.06,
        "The ring should feel clear and restrained but must not feel plain or minimal.",
        "Detail should reward attention without disturbing the clarity of the whole ring."
      );
    }
    return conflicts;
  }

  function decisionConfidenceScore(evidenceConfidence, conflicts) {
    var penalty = conflicts.reduce(function (sum, conflict) { return sum + (conflict.penalty || 0); }, 0);
    return clamp(evidenceConfidence - penalty, 0.35, 1);
  }

  function budgetValue(band) {
    var values = {
      "under-2": 1, "2-4": 2, "4-7.5": 3, "7.5-12": 4, "12-plus": 5,
      "up-to-3": 1, "3-5": 2, "5-8": 3, "8-plus": 4, unknown: 0
    };
    return values[band] || 0;
  }

  function timingAllowsReview(band) {
    return band === "3-6" || band === "6-plus" || band === "open";
  }

  function resultBand(score) {
    if (score >= 76) return "strong";
    if (score >= 68) return "variation";
    if (score >= 64) return "provisional";
    return "weak";
  }

  function honestCollectionCandidates(ranked, answers) {
    var relationshipLeads = ["relationship", "balance"].indexOf(answers.subject) !== -1;
    var relationshipMustShape = relationshipLeads && answers.symbolism === "visible";
    var wearerAsksForOriginalForm =
      ["wearer", "private"].indexOf(answers.subject) !== -1 &&
      ["asymmetric", "talismanic"].indexOf(answers.originality) !== -1;
    var meaningfulStoneDialogue = answers.colour === "dialogue" && answers.symbolism === "visible";

    return ranked.filter(function (candidate) {
      if (!candidate.wearerEligible) return false;
      if (questionFit("avoid", candidate.collection, answers) < 25) return false;
      if (relationshipMustShape && candidate.relationshipScore < 68) return false;
      if (meaningfulStoneDialogue && questionFit("colour", candidate.collection, answers) < 68) return false;
      if (wearerAsksForOriginalForm && questionFit("originality", candidate.collection, answers) < 68) return false;
      return true;
    });
  }

  function hasBlockingConflict(conflicts) {
    var majorCount = conflicts.filter(function (conflict) { return conflict.severity === "major-tension"; }).length;
    return conflicts.some(function (conflict) { return conflict.severity === "blocking"; }) || majorCount >= 2;
  }

  function assessCollectionSuitability(ranked, answers, conflicts, decisionConfidence) {
    var candidates = honestCollectionCandidates(ranked, answers);
    var blocked = hasBlockingConflict(conflicts) || decisionConfidence < 0.70;
    var strong = blocked ? [] : candidates.filter(function (candidate) { return candidate.finalScore >= 76; });
    var directional = blocked ? [] : candidates.filter(function (candidate) { return candidate.finalScore >= 68; });
    return {
      credible: strong.length > 0,
      blocked: blocked,
      candidates: candidates,
      strongCandidates: strong,
      directionalCandidates: directional,
      clientFacingRecommendations: []
    };
  }

  function assessAdaptationSuitability(collectionSuitability, answers, practical, decisionConfidence) {
    var foundations = collectionSuitability.directionalCandidates.filter(function (candidate) {
      return candidate.collection.adaptable === true;
    });
    var boundedChanges = [];
    if (practical.stone === "existing") boundedChanges.push("existing-stone-feasibility");
    if (answers.metal && answers.metal !== "open") boundedChanges.push("metal-direction-to-confirm");
    if (answers.colour && answers.colour !== "open") boundedChanges.push("stone-colour-to-confirm");
    var needsAdaptation = practical.stone === "existing" || !collectionSuitability.credible;
    return {
      credible: decisionConfidence >= 0.70 && needsAdaptation && foundations.length > 0,
      foundations: foundations,
      foundation: foundations[0] || null,
      boundedChanges: boundedChanges,
      unresolvedFeasibility: foundations.length > 0
        ? "Andrew must confirm the actual stone, cut, proportion, price and timing before an adaptation is promised."
        : "No AG family is currently marked as a credible foundation for the requested change."
    };
  }

  function assessBespokeJustification(collectionSuitability, adaptationSuitability, answers, conflicts, decisionConfidence) {
    var directEvidence = ["wearer", "together", "direct"].indexOf(answers.evidence) !== -1;
    var reasons = [];
    var relationshipLeads = ["relationship", "balance"].indexOf(answers.subject) !== -1;
    if (relationshipLeads && answers.symbolism === "visible") {
      reasons.push("The relationship must shape the visible relationship between design elements.");
    }
    if (["asymmetric", "talismanic"].indexOf(answers.originality) !== -1) {
      reasons.push("The brief asks for an unconventional whole-ring form rather than a cosmetic change.");
    }
    if (answers.colour === "dialogue" && answers.symbolism === "visible") {
      reasons.push("The relationship between two stones or colours is part of the design meaning.");
    }
    var justified =
      !collectionSuitability.credible &&
      !adaptationSuitability.credible &&
      !hasBlockingConflict(conflicts) &&
      directEvidence &&
      decisionConfidence >= 0.85 &&
      reasons.length > 0;
    return {
      justified: justified,
      reasons: reasons,
      requiresConversation: true
    };
  }

  function classifyDesignPath(ranked, answers, confidence, architecture) {
    if (!architecture) {
      var fallbackConflicts = detectConflicts(answers, {});
      var fallbackDecisionConfidence = decisionConfidenceScore(confidence, fallbackConflicts);
      var fallbackCollections = assessCollectionSuitability(ranked, answers, fallbackConflicts, fallbackDecisionConfidence);
      var fallbackAdaptation = assessAdaptationSuitability(fallbackCollections, answers, {}, fallbackDecisionConfidence);
      architecture = {
        conflicts: fallbackConflicts,
        decisionConfidence: fallbackDecisionConfidence,
        collectionSuitability: fallbackCollections,
        adaptationSuitability: fallbackAdaptation,
        bespokeJustification: assessBespokeJustification(fallbackCollections, fallbackAdaptation, answers, fallbackConflicts, fallbackDecisionConfidence),
        practical: {}
      };
    }

    if (architecture.decisionConfidence < 0.70 || hasBlockingConflict(architecture.conflicts)) return "review";
    if (architecture.collectionSuitability.credible && architecture.practical.stone !== "existing") return "existing";
    if (architecture.adaptationSuitability.credible) return "adaptation";
    if (architecture.bespokeJustification.justified) return "bespoke";
    return "review";
  }

  function collectionFamilyKey(candidate) {
    if (!candidate || !candidate.collection) return "";
    return candidate.collection.id === "cannele-twist" ? "cannele" : candidate.collection.id;
  }

  function recommendationRolesFor(resultPath, collectionSuitability, ranked, answers) {
    var empty = { closest: null, alternative: null, curveball: null, selected: [] };
    var candidates = collectionSuitability.candidates.filter(function (candidate) { return candidate.finalScore >= 55; });
    if (["bespoke", "review"].indexOf(resultPath) !== -1) {
      candidates = ranked.filter(function (candidate) {
        return candidate.wearerEligible && candidate.finalScore >= 45 && questionFit("avoid", candidate.collection, answers) >= 20;
      });
      if (!candidates.length) return empty;
      var leadCandidates = candidates.filter(function (candidate) {
        return candidate.collection.id !== "emergence";
      });
      if (leadCandidates.length < 2) leadCandidates = candidates;

      function referenceFit(candidate, kind) {
        if (kind === "structure") {
          return questionFit("wholeRing", candidate.collection, answers) * 0.55 +
            questionFit("originality", candidate.collection, answers) * 0.45;
        }
        if (kind === "relationship" && Number.isFinite(candidate.relationshipScore)) {
          return candidate.relationshipScore;
        }
        return questionFit("presence", candidate.collection, answers) * 0.50 +
          questionFit("colour", candidate.collection, answers) * 0.50;
      }

      function strongestReference(kind, excludedFamilies) {
        return leadCandidates.filter(function (candidate) {
          return excludedFamilies.indexOf(collectionFamilyKey(candidate)) === -1;
        }).slice().sort(function (a, b) {
          var fitGap = referenceFit(b, kind) - referenceFit(a, kind);
          if (fitGap) return fitGap;
          return b.finalScore - a.finalScore;
        })[0] || null;
      }

      var structuralReference = strongestReference("structure", []);
      var usedReferenceFamilies = structuralReference ? [collectionFamilyKey(structuralReference)] : [];
      var meaningKind = relationshipMeaningRelevant(answers) ? "relationship" : "wearer";
      var meaningReference = strongestReference(meaningKind, usedReferenceFamilies);
      if (meaningReference) usedReferenceFamilies.push(collectionFamilyKey(meaningReference));
      var wildcardReference = candidates.find(function (candidate) {
        if (usedReferenceFamilies.indexOf(collectionFamilyKey(candidate)) !== -1) return false;
        return Math.max(
          questionFit("presence", candidate.collection, answers),
          questionFit("wholeRing", candidate.collection, answers),
          questionFit("originality", candidate.collection, answers),
          questionFit("colour", candidate.collection, answers)
        ) >= 80;
      }) || candidates.find(function (candidate) {
        return usedReferenceFamilies.indexOf(collectionFamilyKey(candidate)) === -1;
      }) || null;
      var referenceSelection = [structuralReference, meaningReference, wildcardReference].filter(Boolean);
      return {
        closest: structuralReference,
        alternative: meaningReference,
        curveball: wildcardReference,
        selected: referenceSelection,
        referenceMode: true,
        referenceLabels: {
          closest: "Structural reference",
          alternative: meaningKind === "relationship" ? "Relationship reference" : "Expression reference",
          curveball: "Wildcard reference"
        }
      };
    }
    if (["existing", "adaptation"].indexOf(resultPath) === -1) return empty;

    if (!candidates.length) return empty;
    var closest = candidates[0];
    var closestFamily = collectionFamilyKey(closest);
    var alternative = candidates.find(function (candidate) {
      return collectionFamilyKey(candidate) !== closestFamily;
    }) || null;
    var usedFamilies = [closestFamily];
    if (alternative) usedFamilies.push(collectionFamilyKey(alternative));
    var curveballPool = candidates.filter(function (candidate) {
      if (usedFamilies.indexOf(collectionFamilyKey(candidate)) !== -1) return false;
      var fit = Math.max(
        questionFit("presence", candidate.collection, answers),
        questionFit("wholeRing", candidate.collection, answers),
        questionFit("originality", candidate.collection, answers),
        questionFit("colour", candidate.collection, answers)
      );
      return fit >= 80;
    });
    var curveball = curveballPool[0] || candidates.find(function (candidate) {
      return usedFamilies.indexOf(collectionFamilyKey(candidate)) === -1;
    }) || null;
    var selected = [closest, alternative, curveball].filter(Boolean);
    return {
      closest: closest,
      alternative: alternative,
      curveball: curveball,
      selected: selected
    };
  }

  function commercialNextActionFor(result) {
    var practical = result.practical;
    if (result.proposalReview && practical.wearerApproval === "surprise") {
      if (result.decisionConfidence >= 0.85 && ["existing", "adaptation"].indexOf(result.designPath) !== -1) {
        return {
          id: "proposal-route-review",
          cta: "Discuss the best ring route with Andrew",
          reason: "The available wearer evidence is strong enough for a finished surprise ring to remain credible, while a stone-first proposal can still be considered.",
          recommendedProposalRoute: "finished-ring-credible"
        };
      }
      return {
        id: "stone-first-review",
        cta: "Could a stone-first proposal work for me?",
        reason: "The ring direction is not yet certain enough for a finished surprise ring. A carefully selected gemstone can lead the proposal, with the ring designed together afterwards.",
        recommendedProposalRoute: "stone-first"
      };
    }
    if (result.proposalReview) {
      return {
        id: "direction-review",
        cta: "Discuss the best ring route with Andrew",
        reason: "The proposal route and the wearer's involvement need to be clarified before a finished ring is suggested.",
        recommendedProposalRoute: "undecided"
      };
    }
    if (result.designPath === "existing") {
      return {
        id: "collection-conversation",
        cta: "Discuss this brief with Andrew",
        reason: "A credible established AG response exists, subject to stone, metal, proportion, price and availability."
      };
    }
    if (result.designPath === "adaptation") {
      return {
        id: "adaptation-feasibility",
        cta: "Discuss the adaptation with Andrew",
        reason: "An established AG foundation appears credible, but the requested change must be checked before it is promised."
      };
    }
    if (result.designPath === "bespoke" && result.privateReview) {
      return {
        id: "bespoke-review",
        cta: "Request a bespoke review",
        reason: "Original design work appears justified, but scope and price require a real conversation before any commitment."
      };
    }
    if (result.route === "constrained") {
      return {
        id: "nurture",
        cta: "Keep this Design Brief",
        reason: "The design direction is useful, but the current timing or investment range does not support a defined commission route."
      };
    }
    if (result.conflicts && result.conflicts.length) {
      return {
        id: "direction-review",
        cta: "Ask Andrew to review the direction",
        reason: "The wearer evidence may be strong, but parts of the brief pull in different directions. Andrew should resolve those points before naming a ring or design route."
      };
    }
    return {
      id: "direction-review",
      cta: "Ask Andrew to review the direction",
      reason: "More evidence or clarification is needed before a collection, adaptation or bespoke route is stated."
    };
  }

  function computeResults(answers, practical, contact) {
    answers = normaliseConditionalAnswers(answers || state.answers);
    practical = practical || state.practical;
    contact = contact || state.contact || {};
    var all = collections.map(function (collection) { return scoreCollection(collection, answers, practical); });
    var eligible = all.filter(function (item) { return item.wearerEligible; });
    var pool = eligible.length >= 3 ? eligible : all;
    pool.sort(function (a, b) {
      if (b.finalScore !== a.finalScore) return b.finalScore - a.finalScore;
      if (b.wearerScore !== a.wearerScore) return b.wearerScore - a.wearerScore;
      if (b.practicalPenalty !== a.practicalPenalty) return b.practicalPenalty - a.practicalPenalty;
      return a.collection.id.localeCompare(b.collection.id);
    });
    var top = pool[0];
    var evidenceConfidence = confidenceScore(answers, practical, contact);
    var conflicts = detectConflicts(answers, practical);
    var decisionConfidence = decisionConfidenceScore(evidenceConfidence, conflicts);
    var designDirection = designDirectionFromAnswers(answers, practical);
    var collectionSuitability = assessCollectionSuitability(pool, answers, conflicts, decisionConfidence);
    var adaptationSuitability = assessAdaptationSuitability(collectionSuitability, answers, practical, decisionConfidence);
    var bespokeJustification = assessBespokeJustification(collectionSuitability, adaptationSuitability, answers, conflicts, decisionConfidence);
    var architecture = {
      conflicts: conflicts,
      decisionConfidence: decisionConfidence,
      collectionSuitability: collectionSuitability,
      adaptationSuitability: adaptationSuitability,
      bespokeJustification: bespokeJustification,
      practical: practical
    };
    var designPath = classifyDesignPath(pool, answers, evidenceConfidence, architecture);
    var proposalReview =
      isSoloPartnerChooser(answers) &&
      ["surprise", "unknown"].indexOf(practical.wearerApproval) !== -1;
    var directEvidence = ["wearer", "together", "direct"].indexOf(answers.evidence) !== -1;
    var privateReview =
      designPath === "bespoke" &&
      decisionConfidence >= 0.90 &&
      directEvidence &&
      budgetValue(practical.budget) >= 4 &&
      timingAllowsReview(practical.timing);

    var route = "nurture";
    if (designPath === "review") route = "nurture";
    else if (practical.budget === "under-2" || practical.timing === "under-6") route = "constrained";
    else if (privateReview) route = "private-review";
    else if (designPath === "bespoke") route = "nurture";
    else if (top.finalScore >= 68 && practical.stone === "existing" && budgetValue(practical.budget) >= 3 && timingAllowsReview(practical.timing)) route = "considered-variation";
    else if (top.finalScore >= 68) route = "collection-direction";

    var recommendationRoles = recommendationRolesFor(designPath, collectionSuitability, pool, answers);
    collectionSuitability.clientFacingRecommendations = recommendationRoles.selected;
    var compatibilityRecommendations = recommendationRoles.selected.length
      ? recommendationRoles.selected
      : pool.slice(0, 3);
    var result = {
      ranked: pool,
      allScores: all,
      top: top,
      recommendations: compatibilityRecommendations,
      confidence: evidenceConfidence,
      evidenceConfidence: evidenceConfidence,
      decisionConfidence: decisionConfidence,
      band: resultBand(top.finalScore),
      gap: pool.length > 1 ? top.finalScore - pool[1].finalScore : 100,
      ambiguousRouting: pool.length > 1 && (top.finalScore - pool[1].finalScore) < 2,
      designPath: designPath,
      route: route,
      privateReview: privateReview,
      proposalReview: proposalReview,
      practical: practical,
      designDirection: designDirection,
      conflicts: conflicts,
      collectionSuitability: collectionSuitability,
      adaptationSuitability: adaptationSuitability,
      bespokeJustification: bespokeJustification,
      recommendationRoles: recommendationRoles
    };
    result.commercialNextAction = commercialNextActionFor(result);
    return result;
  }

  function confidenceLabel(score) {
    if (score >= 0.85) return "Well-supported brief";
    if (score >= 0.70) return "Credible direction";
    return "Early direction, based on limited wearer evidence";
  }

  function titleForResult() {
    return "What the ring should express";
  }

  function designPathContent(path) {
    var content = {
      existing: {
        title: "An existing AG design",
        copy: "One or more established AG designs already carry the form and expression your answers point towards. They remain possible responses, not automatic selections. Stone, metal, proportion and availability still need to be confirmed with Andrew."
      },
      adaptation: {
        title: "A considered adaptation",
        copy: "An existing AG design language appears to provide the right foundation, but your brief asks for a more particular balance of wearer, relationship, form or stone. The examples below are starting points, not finished answers."
      },
      bespoke: {
        title: "A fully bespoke conversation",
        copy: "Your answers ask the wearer or relationship to shape the ring itself, and no existing AG design resolves that combination strongly enough. This points towards a fully bespoke conversation with Andrew. It is not an automatic acceptance, finished design or quotation.",
        capacity: "Andrew takes on no more than two fully bespoke ring commissions each month. This protects the time required for a personal design conversation, careful development and refinement. Availability, scope and the design fee are confirmed before original design work begins."
      },
      review: {
        title: "A private design review",
        copy: "No existing AG piece should yet be presented as the answer, but the pattern of answers does not justify declaring the ring fully bespoke. Andrew should review the brief personally before deciding between adaptation and fully bespoke."
      }
    };
    return content[path] || content.review;
  }

  function recommendationPresentation(path) {
    if (path === "existing") {
      return {
        eyebrow: "Possible existing responses",
        heading: "Existing AG designs that may answer this brief",
        intro: "These are ordered by how closely they reflect your brief. They are possible responses, not automatic recommendations. One may work as it is once stone, metal, specification, price and timing are confirmed with Andrew.",
        close: "You do not need to choose one. Your response to the forms and details is useful evidence for a conversation with Andrew.",
        cardLabel: "Possible response"
      };
    }
    return {
      eyebrow: "Possible starting points",
      heading: "AG design languages that could become a starting point",
      intro: "These examples answer parts of the brief. None is presented as the finished ring. Andrew may identify one as a sound foundation for a considered adaptation.",
      close: "You do not need to choose one. Notice what each example gets right, and what still feels absent.",
      cardLabel: "Possible starting point"
    };
  }

  function personalisationContent(path) {
    var content = {
      existing: {
        heading: "An established piece may already be the answer.",
        copy: "The brief appears to align with an existing AG design language. The next step is to test the actual design, stone, metal and proportion against the wearer rather than invent changes for their own sake.",
        note: "Some Andrew Geoghegan designs that may be suggested in your brief are not currently listed online. They can still be ordered. Andrew can confirm the available stone options, price and timing."
      },
      adaptation: {
        heading: "A design language can be the beginning, not the conclusion.",
        copy: "An existing AG design may provide the right foundation while a particular stone, proportion or meaningful detail brings the brief into focus. Andrew will first test what the established design can honestly support.",
        note: "A considered adaptation is not speculative bespoke work. Feasibility, scope, price and timing are agreed before any commitment. If original design work is genuinely required, its design fee is agreed before sketches, CAD or stone sourcing begin."
      },
      bespoke: {
        heading: "The brief is the beginning, not the finished design.",
        copy: "This Design Brief identifies why fully bespoke may be worth exploring. It is not a finished design generated by a quiz. Andrew develops each bespoke ring personally through conversation, design work and refinement.",
        note: "For engagement rings, original design work begins after an agreed design fee, normally from £1,000. The finished ring is priced separately."
      },
      review: {
        heading: "More understanding should come before a design route.",
        copy: "The brief has identified a useful direction, but it would be premature to present an existing ring or declare the piece fully bespoke. Andrew can review the evidence and identify what needs to be understood next.",
        note: "A private review starts a conversation only. It does not commit either side to a ring, design fee or commission."
      }
    };
    return content[path] || content.review;
  }

  function resultPhrases(answers) {
    var presence = { quiet: "Quietly present", assured: "Assured", expressive: "Expressive", unmistakable: "Unmistakable" };
    var form = { classical: "Classically resolved", departure: "Classic, with a twist", architectural: "Architectural", asymmetric: "Deliberately asymmetric", talismanic: "Flowing and unconventional" };
    var light = { structure: "Form and line led", depth: "Depth and shadow", restraint: "Clear and restrained" };
    var stone = {
      white: "White and bright",
      accent: "Light-led, with a note of colour",
      centre: "Colour at the centre",
      dialogue: "Two stones in dialogue",
      open: "Stone and colour still open"
    };
    var third = answers.wholeRing === "light" ? (stone[answers.colour] || "Light-led") : (light[answers.wholeRing] || stone[answers.colour] || "One resolved whole");
    return [presence[answers.presence] || "Considered", form[answers.originality] || "Distinctively resolved", third];
  }

  function evidenceExplainer(answers) {
    var copy = {
      wearer: "This brief is based on the wearer’s own answers.",
      together: "This brief is based on answers considered together.",
      direct: "This brief is supported by ring images the wearer has suggested.",
      observed: "This brief is informed by the wearer’s existing jewellery, clothes and objects.",
      confident: "This is a first direction based on a good understanding of the wearer’s style, with few direct ring clues.",
      limited: "This is an early direction. It is useful for identifying what to explore, rather than making a final choice."
    };
    return copy[answers.evidence] || copy.limited;
  }
  function interpretationText(answers) {
    answers = normaliseConditionalAnswers(answers);
    var presence = {
      quiet: "quiet presence",
      assured: "assured presence",
      expressive: "expressive presence",
      unmistakable: "unmistakable presence"
    };
    var form = {
      classical: "a classically resolved form",
      departure: "a recognisable form with one distinctive feature",
        architectural: "an architectural form with precise lines",
      asymmetric: "controlled asymmetry",
        talismanic: "a flowing design unlike a traditional engagement ring"
    };
    var wholeRing = {
      light: "with light and the stones taking the lead across the whole ring",
        structure: "the form and lines of the ring itself giving the whole ring its character",
      depth: "depth, space and shadow becoming apparent as the hand moves",
      restraint: "clarity and restraint carrying the design from every angle"
    };
    var subject = {
      wearer: "The character and style of the wearer should lead; any relationship meaning should support rather than control the design.",
      relationship: "The relationship is a genuine design subject, but it should be expressed through the ring’s form and proportions without relying on an obvious symbol.",
      private: "The wearer should lead, with the relationship carried more quietly through proportion or form.",
      balance: "The character of the wearer and the qualities of the relationship should carry equal weight in the design."
    };
    var symbolism = {
      form: "Meaning does not need a visible symbol; the form itself can carry it.",
      discreet: "Meaning may influence the form discreetly, without becoming an obvious motif.",
      visible: "Meaning may be expressed more clearly through the relationship between distinct design elements."
    };
    var colour = {
      white: "White light should lead, keeping attention on form, proportion and the behaviour of the setting.",
      accent: "Colour should act as a restrained accent, adding character without becoming the whole identity of the ring.",
      centre: "A coloured stone should provide the emotional centre and carry the first impression.",
      dialogue: "Two colours or stones may create a dialogue, provided the pairing feels integral rather than merely decorative.",
      open: "Stone and colour can remain open until the form and emotional direction have been explored with Andrew."
    };
    var subjectCopy = subject[answers.subject] || subject.balance;
    var symbolismCopy = symbolism[answers.symbolism] || "";
    if (isSelfWearerOnly(answers)) {
      subjectCopy = "The ring should express the character and style of the wearer. It does not need to carry relationship meaning.";
      symbolismCopy = "";
    } else if (!relationshipMeaningRelevant(answers)) {
      subjectCopy = "The character and style of the wearer should lead. The relationship gives the ring personal meaning, but does not need to influence how it looks.";
      symbolismCopy = "";
    }
    return "Your answers point towards a ring with " + (presence[answers.presence] || "considered presence") + ", " + (form[answers.originality] || "a resolved form") + " " + (wholeRing[answers.wholeRing] || "with one coherent idea carried through the whole object") + ". " +
      subjectCopy + " " +
      (symbolismCopy ? symbolismCopy + " " : "") +
      (colour[answers.colour] || colour.open);
  }

  function wearerHeading(answer) {
    var map = {
      quiet: "Quiet confidence, with detail that rewards attention.",
      assured: "Distinctive, considered and beautifully balanced.",
      expressive: "Visible character without empty spectacle.",
      unmistakable: "A ring with genuine presence."
    };
    return map[answer] || "A clear sense of the wearer.";
  }

  function wearerCopy(answers) {
    var presence = {
      quiet: "The ring should belong easily on the hand and disclose its intelligence at close range.",
      assured: "The ring should feel clearly designed, but remain composed enough for daily life.",
      expressive: "The answers favour an expressive piece, provided every gesture has a reason.",
      unmistakable: "Scale and silhouette may be confident. Restraint should come from precision, not from making the ring disappear."
    };
    var wholeRing = {
      light: "Light and the stones should lead, while the setting, profile and band remain one resolved object.",
        structure: "The form and lines of the ring, including the transition from setting into band, should give the whole ring its character.",
      depth: "Openings, layers and shadow should enrich the ring as the hand moves, without becoming separate decorative tricks.",
      restraint: "Clarity and restraint should continue through the setting, profile and band."
    };
    var originality = {
      classical: "The form can stay connected to familiar ring traditions.",
      departure: "The ring can stay recognisable while one feature makes it distinctive.",
      architectural: "Geometry and precise lines should provide the originality.",
      asymmetric: "The brief is open to controlled asymmetry as a considered design choice, not a novelty.",
        talismanic: "A flowing design can follow its own rhythm."
    };
    var evidence = {
      wearer: "The brief uses direct input from the wearer.",
      together: "The brief uses answers considered by both people.",
      direct: "The brief uses ring images supplied or suggested by the wearer as evidence.",
      observed: "The direction is informed by the jewellery, clothes and objects they already choose.",
      confident: "The direction is informed by a strong personal understanding, with few direct ring clues.",
      limited: "Treat this as a useful first direction to test with Andrew, not a fixed verdict on their style."
    };
    var avoided = answerTextFrom(answers, "avoid").toLowerCase();
    var end = avoided && avoided.indexOf("nothing here") === -1 ? " It must not feel " + avoided + "." : "";
    return (presence[answers.presence] || "") + " " + (wholeRing[answers.wholeRing] || "") + " " + (originality[answers.originality] || "") + end + " " + (evidence[answers.evidence] || evidence.limited);
  }

  function answerTextFrom(answers, questionId) {
    var question = getQuestion(questionId);
    var value = answers[questionId];
    if (!question || value == null) return "";
    if (Array.isArray(value)) {
      return value.map(function (id) {
        var option = getOption(questionId, id);
        return option ? option.label : id;
      }).join(" and ");
    }
    var option = getOption(questionId, value);
    return option ? option.label : value;
  }

  function relationshipHeading(answers) {
    if (!relationshipMeaningRelevant(answers)) {
      return "The wearer leads without a relationship theme shaping the design.";
    }
    var map = {
      wearer: "Meaning can support the ring without directing it.",
      relationship: "The relationship is a genuine design subject.",
      private: "The wearer leads, with the relationship included more subtly.",
      balance: "The wearer and the relationship deserve equal consideration."
    };
    return map[answers.subject] || map.balance;
  }

  function relationshipCopy(answers) {
    answers = normaliseConditionalAnswers(answers);
    if (isSelfWearerOnly(answers)) return "";
    if (!relationshipMeaningRelevant(answers)) {
      return "The relationship gives the ring personal meaning, but the design itself should be guided by the wearer's character and style.";
    }
    var relation = answerTextFrom(answers, "relationship").toLowerCase();
    var symbol = {
      form: "The design does not need to explain that meaning literally.",
      discreet: "That meaning may shape part of the design discreetly, without becoming an obvious motif.",
      visible: "That meaning may be expressed more clearly through the relationship between distinct design elements."
    };
    var opening = "The relationship was described through " + relation + ". ";
    if (answers.subject === "wearer") opening = "The relationship matters, but the wearer's taste retains the final say. It was described through " + relation + ". ";
    return opening + (symbol[answers.symbolism] || "");
  }

  function expressionHeading(result) {
    return "Each answer is a clue. Together, they create the direction.";
  }

  function expressionCopy(answers, result) {
    var avoid = answerTextFrom(answers, "avoid");
    var boundary = avoid && avoid.indexOf("Nothing here") === -1 ? " The qualities you rejected are treated as design boundaries: " + avoid.toLowerCase() + "." : "";
    return "No single answer chooses a ring. Presence, form and what should lead across the whole ring establish its character. Colour, metal and any relationship meaning then refine that direction. The choices you rejected are equally useful because they define what the ring should avoid." + boundary;
  }

  function practicalLabel(group, value) {
    var labels = {
      wear: {
        active: "Active daily wear",
        careful: "Daily wear, removed for rough work",
        occasion: "Selected-occasion wear",
        unknown: "Wearing pattern still open"
      },
      budget: {
        "up-to-3": "Investment range for the complete ring: up to £3,000",
        "3-5": "Investment range for the complete ring: £3,000 to £5,000",
        "5-8": "Investment range for the complete ring: £5,000 to £8,000",
        "8-plus": "Investment range for the complete ring: £8,000 or more",
        "under-2": "Investment range for the complete ring: below £2,000",
        "2-4": "Investment range for the complete ring: £2,000 to £4,000",
        "4-7.5": "Investment range for the complete ring: £4,000 to £7,500",
        "7.5-12": "Investment range for the complete ring: £7,500 to £12,000",
        "12-plus": "Investment range for the complete ring: £12,000 or more",
        unknown: "Investment range for the complete ring: would rather not say"
      },
      timing: {
        "under-6": "Needed within six weeks",
        "6-12": "Needed in six to twelve weeks",
        "3-6": "Needed in three to six months",
        "6-plus": "Needed more than six months from now",
        open: "No fixed date"
      },
      stone: {
        open: "Stone type still open",
        "natural-diamond": "Natural diamond is the current instinct",
        "lab-diamond": "Lab-grown diamond is the current instinct, subject to design compatibility",
        coloured: "A coloured gemstone is the current instinct",
        existing: "One existing stone is available to review"
      },
      wearerApproval: {
        together: "The finished ring will be confirmed together before the proposal",
        surprise: "The finished ring needs to remain a surprise",
        "not-proposal": "This ring is not for a proposal",
        unknown: "The proposal route is not yet decided"
      }
    };
    return labels[group] && labels[group][value] ? labels[group][value] : "Still open";
  }

  function glanceItems(answers, practical) {
    answers = normaliseConditionalAnswers(answers);
    var presence = {
      quiet: "Quiet, rewarding close attention",
      assured: "Assured, composed and clearly designed",
      expressive: "Expressive, without empty spectacle",
      unmistakable: "Unmistakable, with precision providing restraint"
    };
    var form = {
      classical: "Classically resolved",
      departure: "Recognisable, with one distinctive feature",
      architectural: "Architectural, with precise lines",
      asymmetric: "Controlled asymmetry",
        talismanic: "Flowing and unconventional"
    };
    var wholeRing = {
      light: "Light and the stones should lead",
        structure: "The form and lines of the ring itself should lead",
      depth: "Depth, space and shadow should lead",
      restraint: "Clarity and restraint should lead"
    };
    var subject = {
      wearer: "Wearer-led, with relationship meaning in support",
      relationship: "Relationship-led",
      private: "Wearer-led, with the relationship included subtly",
      balance: "Wearer and relationship equally weighted"
    };
    var theme = {
      steadiness: "steadiness and endurance",
      independence: "independence and repeated choice",
      lightness: "lightness, optimism and celebration",
      intimacy: "protection and intimacy",
      change: "change, adventure and movement",
      private: "something private that needs no explanation"
    };
    var symbolism = {
      form: "carried by the form itself",
      discreet: "carried discreetly through the form",
      visible: "expressed through the relationship between design elements"
    };
    var colour = {
      white: "White light should lead",
      accent: "A restrained note of colour",
      centre: "A coloured stone as the emotional centre",
      dialogue: "A dialogue between two colours or stones",
      open: "Colour remains open until the form is clearer"
    };
    var metal = {
      white: "Cool and luminous: platinum or white gold",
      yellow: "Warm and rich: yellow gold",
      rose: "Softly warm: rose gold",
      two: "A considered contrast between two metals",
      open: "Metal remains open until the stone and design are clearer"
    };
    var stone = practicalLabel("stone", practical.stone);
    var conflict = (answers.colour === "white" && practical.stone === "coloured") ||
      (["centre", "dialogue"].indexOf(answers.colour) !== -1 && ["natural-diamond", "lab-diamond"].indexOf(practical.stone) !== -1);
    if (conflict) stone += ". This is one point to resolve with Andrew";
    var meaning = (subject[answers.subject] || subject.balance) + "; " + (theme[answers.relationship] || "meaning still open") + ", " + (symbolism[answers.symbolism] || symbolism.form);
    if (isSelfWearerOnly(answers)) {
      meaning = "Wearer-led; no relationship meaning requested";
    } else if (!relationshipMeaningRelevant(answers)) {
      meaning = "Wearer-led; the relationship does not need to shape how the ring looks";
    }
    var practicalSummary =
      practicalLabel("wear", practical.wear) + ". " +
      practicalLabel("budget", practical.budget) + ". " +
      practicalLabel("timing", practical.timing);
    if (practical.wearerApproval) {
      practicalSummary += ". " + practicalLabel("wearerApproval", practical.wearerApproval);
    }
    return [
      ["Presence", presence[answers.presence] || "Considered and composed"],
      ["Form", form[answers.originality] || "To be explored"],
      ["Whole-ring character", (wholeRing[answers.wholeRing] || "One coherent idea carried through the whole object")],
      ["Meaning", meaning],
      ["Stone, colour and metal", (colour[answers.colour] || colour.open) + ". " + (metal[answers.metal] || metal.open) + ". " + stone],
      ["Practical considerations", practicalSummary]
    ];
  }

  function practicalContent(result, practical) {
    var timing = {
      "under-6": "within six weeks",
      "6-12": "in six to twelve weeks",
      "3-6": "in three to six months",
      "6-plus": "more than six months away",
      open: "with no fixed date"
    };
    var wear = {
      active: "active daily wear",
      careful: "daily wear with the ring removed for rough work",
      occasion: "selected-occasion wear",
      unknown: "a wearing pattern that is not yet known"
    };
    var budget = {
      "up-to-3": "up to £3,000",
      "3-5": "£3,000 to £5,000",
      "5-8": "£5,000 to £8,000",
      "8-plus": "£8,000 or more",
      "under-2": "below £2,000",
      "2-4": "£2,000 to £4,000",
      "4-7.5": "£4,000 to £7,500",
      "7.5-12": "£7,500 to £12,000",
      "12-plus": "£12,000 or more",
      unknown: "not disclosed"
    };
    var heading = "What needs confirming next.";
    var copy = "These details do not alter the design direction. They help identify which options are realistic to explore next. The practical brief is " + (wear[practical.wear] || "daily wear") + ", an investment range of " + (budget[practical.budget] || "not disclosed") + ", and a required date " + (timing[practical.timing] || "to be agreed") + ".";
    if (practical.stone === "lab-diamond") copy += " A preference for lab-grown diamond is recorded. Lab-grown options are quoted individually because they are not currently included in the prices shown on the AG website.";
    if (practical.stone === "existing") copy += " One existing stone can be reviewed as a possible starting point. Suitability and setting feasibility are not assumed.";
    if (result.proposalReview) {
      copy += " Because the finished ring must remain a surprise, or the approval route is not yet decided, Andrew should help plan whether a completed ring, a stone-led proposal or a design refined together afterwards is the safest next step.";
    }
    if (result.route === "constrained" && practical.timing === "under-6") {
      heading = "Current pieces and confirmed availability must lead.";
      copy += " A date inside six weeks rules out assuming that a new commission or made-to-order ring can be completed. Andrew must confirm any viable piece and delivery date.";
    } else if (result.route === "constrained" && practical.budget === "under-2") {
      heading = "Keep the direction, but test the investment honestly.";
      copy += " This sits below the normal level of most AG fine-jewellery commissions. The brief remains useful, but it should not be turned into a promise of bespoke work.";
    } else if (result.proposalReview) {
      heading = "Plan the proposal without guessing the finished ring.";
    } else if (result.designPath === "bespoke") {
      heading = "Test whether the bespoke direction is practically viable.";
      copy += " The design answers point towards a bespoke conversation, but Andrew must still confirm that the investment, timing, stone and wearing brief support a fully bespoke commission.";
    } else if (result.designPath === "review") {
      heading = "A private design review is the practical next step.";
      copy += " No existing collection yet resolves the brief strongly enough, but the result should not guess whether adaptation or fully bespoke is the better route. Andrew should review the evidence personally.";
    }
    copy += " No stone, price, ring size, availability or delivery date is confirmed by this brief. Andrew verifies each against the actual piece.";
    return { heading: heading, copy: copy };
  }

  function extendedSettingArrangementContent(practical) {
    if (!practical || !practical.extendedSettingArrangement) return null;
    return {
      heading: "A wider setting arrangement",
      copy: "You indicated that you would also consider a setting arrangement extending beyond one top-centre focus. This might mean a wider three-stone composition or detail continuing further around the ring. The questionnaire primarily considers the ring's character and design language, so this preference has been recorded separately and has not been used to force a different collection recommendation. If you choose to discuss your brief, Andrew can explore how it could work within an existing design, an adaptation or a bespoke direction."
    };
  }

  function scopeContent(result) {
    if (result.designPath === "bespoke") {
      return {
        title: "A bespoke direction, not a finished design",
        copy: "Andrew decides personally whether the brief is suitable for a fully bespoke commission. Original design work begins only after an agreed design fee. For an engagement ring, this is normally from £1,000. Other briefs are confirmed individually. The finished ring is priced separately. Sketches, CAD and stone sourcing do not begin speculatively."
      };
    }
    if (result.designPath === "review") {
      return {
        title: "A review before the route is chosen",
        copy: "This result does not force a product match or declare the ring bespoke. Andrew can review the brief, identify what evidence is missing and decide whether an existing design, a considered adaptation or a fully bespoke commission deserves further exploration."
      };
    }
    if (result.designPath === "adaptation") {
      return {
        title: "Existing design first, considered variation second",
        copy: "An established AG design language remains the starting point. A different stone or detail may be reviewed, but feasibility, price and timing are confirmed before any commitment. Original design work, if genuinely required, begins only after an agreed design fee."
      };
    }
    return {
      title: "What this result does and does not decide",
      copy: "This Design Brief identifies existing AG designs that may answer the direction. It does not select a finished ring or confirm a stone, price, ring size, availability or delivery date. Andrew verifies those details against the actual piece before an order."
    };
  }

  function answerRecapItems(answers) {
    answers = normaliseConditionalAnswers(answers);
    var items = [
      ["Presence and form", answerTextFrom(answers, "presence") + "; " + answerTextFrom(answers, "originality")],
      ["Whole-ring character", answerTextFrom(answers, "wholeRing")],
      ["Stone, colour and metal", answerTextFrom(answers, "colour") + "; " + answerTextFrom(answers, "metal")],
      ["Must not feel", answerTextFrom(answers, "avoid")],
      ["Evidence used", answerTextFrom(answers, "evidence")]
    ];
    if (isSelfWearerOnly(answers)) {
      items.splice(3, 0, ["Meaning", "Self-purchase; no relationship meaning requested"]);
    } else if (!relationshipMeaningRelevant(answers)) {
      items.splice(3, 0, ["Meaning", "Let the wearer lead; no relationship quality was asked"]);
    } else {
      items.splice(3, 0, ["Meaning and relationship", answerTextFrom(answers, "symbolism") + "; " + answerTextFrom(answers, "relationship")]);
    }
    return items;
  }

  function recommendationReason(item, answers) {
    var c = item.collection;
    var signals = [
      { label: "presence", score: questionFit("presence", c, answers) },
      { label: "form", score: questionFit("originality", c, answers) },
      { label: "whole-ring character", score: questionFit("wholeRing", c, answers) },
      { label: "stone and colour", score: questionFit("colour", c, answers) }
    ];
    if (relationshipMeaningRelevant(answers)) {
      signals.push({ label: "relationship meaning", score: mean([questionFit("symbolism", c, answers), questionFit("relationship", c, answers)]) });
    }
    signals.sort(function (a, b) { return b.score - a.score; });
    var strongest = signals.filter(function (signal) { return signal.score >= 62; }).slice(0, 2);
    if (strongest.length < 2) return c.summary + " Treat it as an exploratory contrast rather than a prescription.";
    return c.summary + " Explore it as one possible expression of your preferences for " + strongest[0].label + " and " + strongest[1].label + ".";
  }

  function renderRecommendations(result, answers) {
    var grid = document.getElementById("recommendation-grid");
    grid.innerHTML = "";
    var presentation = recommendationPresentation(result.designPath);
    if (result.proposalReview) {
      presentation = {
        eyebrow: "References for a proposal conversation",
        heading: "AG design languages Andrew may use to test the direction",
        intro: "These are conversation references, not approval of a finished surprise ring. Andrew can use them to discuss a safe proposal route while protecting the option to refine the ring together afterwards.",
        close: "You do not need to choose one. The useful response is what feels right, what feels wrong and how much must remain open for the wearer.",
        cardLabel: "Conversation reference"
      };
    }
    var displayed = [
      { role: "Closest response", item: result.recommendationRoles && result.recommendationRoles.closest },
      { role: "Credible alternative", item: result.recommendationRoles && result.recommendationRoles.alternative },
      { role: "A different direction worth considering", item: result.recommendationRoles && result.recommendationRoles.curveball }
    ].filter(function (entry) { return !!entry.item; });
    if (!displayed.length) {
      displayed = result.recommendations.map(function (item) {
        return { role: presentation.cardLabel, item: item };
      });
    }
    displayed.forEach(function (entry) {
      var item = entry.item;
      var card = document.createElement("article");
      card.className = "recommendation-card";
      var image = document.createElement("img");
      var selectedImage = collectionImageFor(item.collection, answers);
      image.src = selectedImage;
      // A missing deployment asset must not leave a recommendation card blank.
      // The established Shopify image remains the safe fallback until an
      // asset URL has been verified in the live environment.
      if (selectedImage !== item.collection.image) {
        image.addEventListener("error", function () {
          this.onerror = null;
          this.src = this.dataset.fallbackImage;
        });
        image.dataset.fallbackImage = item.collection.image;
      }
      image.alt = item.collection.name + " ring by Andrew Geoghegan";
      image.loading = "lazy";
      card.appendChild(image);
      var copy = document.createElement("div");
      copy.className = "recommendation-card-copy";
      var rank = document.createElement("p");
      rank.className = "recommendation-rank";
      rank.textContent = entry.role;
      var title = document.createElement("h3");
      title.textContent = item.collection.name;
      var reason = document.createElement("p");
      reason.textContent = recommendationReason(item, answers) + (entry.role === "A different direction worth considering"
        ? " This is included as a useful contrast, not because it matches every answer."
        : "");
      var link = document.createElement("a");
      link.className = "text-cta";
      link.href = item.collection.url;
      link.target = "_blank";
      link.rel = "noopener";
      link.textContent = "Explore " + item.collection.name;
      copy.appendChild(rank);
      copy.appendChild(title);
      copy.appendChild(reason);
      copy.appendChild(link);
      card.appendChild(copy);
      grid.appendChild(card);
    });

    document.getElementById("recommendations-eyebrow").textContent = presentation.eyebrow;
    document.getElementById("recommendations-heading").textContent = presentation.heading;
    document.getElementById("recommendations-intro").textContent = presentation.intro;
    document.getElementById("recommendations-close").textContent = presentation.close;
  }

  function renderBespokeExamples() {
    var section = document.getElementById("bespoke-examples");
    var grid = document.getElementById("bespoke-example-grid");
    var valid = bespokeExamples.filter(function (example) {
      return example && example.image && example.brief && example.response;
    }).slice(0, 3);
    grid.innerHTML = "";
    if (!valid.length) {
      section.hidden = true;
      return false;
    }
    valid.forEach(function (example) {
      var card = document.createElement("article");
      card.className = "recommendation-card";
      var image = document.createElement("img");
      image.src = example.image;
      image.alt = example.alt || "A fully bespoke ring designed by Andrew Geoghegan";
      image.loading = "lazy";
      card.appendChild(image);
      var copy = document.createElement("div");
      copy.className = "recommendation-card-copy bespoke-case-copy";
      var label = document.createElement("p");
      label.className = "recommendation-rank";
      label.textContent = "Bespoke case study";
      var title = document.createElement("h3");
      title.textContent = example.title || "A particular brief, resolved personally";
      var brief = document.createElement("p");
      var briefLabel = document.createElement("strong");
      briefLabel.textContent = "The brief. ";
      brief.appendChild(briefLabel);
      brief.appendChild(document.createTextNode(example.brief));
      var response = document.createElement("p");
      var responseLabel = document.createElement("strong");
      responseLabel.textContent = "The design response. ";
      response.appendChild(responseLabel);
      response.appendChild(document.createTextNode(example.response));
      copy.appendChild(label);
      copy.appendChild(title);
      copy.appendChild(brief);
      copy.appendChild(response);
      card.appendChild(copy);
      grid.appendChild(card);
    });
    section.hidden = false;
    return true;
  }

  function renderResult(result, contact) {
    state.result = result;
    state.contact = contact;
    elements.intro.hidden = true;
    elements.proof.hidden = true;
    elements.quiz.hidden = true;
    elements.result.hidden = false;

    document.getElementById("result-kicker").textContent = contact.firstName
      ? contact.firstName + ", your Ring Design Brief"
      : "Your Ring Design Brief";
    document.getElementById("result-title").textContent = titleForResult();
    document.getElementById("result-intro").textContent = interpretationText(state.answers);

    var phraseList = document.getElementById("result-phrases");
    phraseList.innerHTML = "";
    resultPhrases(state.answers).forEach(function (phrase) {
      var item = document.createElement("li");
      item.textContent = phrase;
      phraseList.appendChild(item);
    });

    var consultationContact = document.getElementById("consultation-contact");
    var consultationFirstName = document.getElementById("consultation-first-name");
    var consultationEmail = document.getElementById("consultation-email");
    var needsConsultationContact = !contact.email;
    consultationContact.hidden = !needsConsultationContact;
    consultationFirstName.required = needsConsultationContact;
    consultationEmail.required = needsConsultationContact;
    consultationFirstName.value = contact.firstName || "";
    consultationEmail.value = contact.email || "";

    var path = result.designPath || "review";
    var pathCopy = designPathContent(path);
    document.getElementById("result-route-title").textContent = pathCopy.title;
    var routeCopy = pathCopy.copy;
    if (result.conflicts && result.conflicts.length) {
      routeCopy += " Your answers also contain " + (result.conflicts.length === 1 ? "one point" : "some points") + " that should be considered rather than averaged away. " +
        result.conflicts.map(function (conflict) { return conflict.explanation; }).join(" ");
    }
    document.getElementById("result-route-copy").textContent = routeCopy;
    var capacity = document.getElementById("result-route-capacity");
    capacity.hidden = !pathCopy.capacity;
    capacity.textContent = pathCopy.capacity || "";

    document.getElementById("wearer-heading").textContent = wearerHeading(state.answers.presence);
    document.getElementById("wearer-copy").textContent = wearerCopy(state.answers);
    var confidenceCopy = evidenceExplainer(state.answers);
    if (result.decisionConfidence < result.evidenceConfidence) {
      confidenceCopy += " Some choices point in different directions, so Andrew would resolve those with you before treating this as a final route.";
    }
    document.getElementById("confidence-line").textContent = confidenceCopy;
    var relationshipDetail = document.getElementById("relationship-detail");
    var hideRelationshipDetail = isSelfWearerOnly(state.answers);
    relationshipDetail.hidden = hideRelationshipDetail;
    if (!hideRelationshipDetail) {
      document.getElementById("relationship-heading").textContent = relationshipHeading(state.answers);
      document.getElementById("relationship-copy").textContent = relationshipCopy(state.answers);
    }
    document.getElementById("expression-heading").textContent = expressionHeading(result);
    document.getElementById("expression-copy").textContent = expressionCopy(state.answers, result);

    var list = document.getElementById("result-summary");
    list.innerHTML = "";
    glanceItems(state.answers, state.practical).forEach(function (item) {
      var li = document.createElement("li");
      var strong = document.createElement("strong");
      strong.textContent = item[0];
      var span = document.createElement("span");
      span.textContent = item[1];
      li.appendChild(strong);
      li.appendChild(span);
      list.appendChild(li);
    });

    var recap = document.getElementById("answer-recap");
    recap.innerHTML = "";
    answerRecapItems(state.answers).forEach(function (item) {
      var term = document.createElement("dt");
      var description = document.createElement("dd");
      term.textContent = item[0];
      description.textContent = item[1];
      recap.appendChild(term);
      recap.appendChild(description);
    });

    var practical = practicalContent(result, state.practical);
    document.getElementById("route-heading").textContent = practical.heading;
    document.getElementById("route-copy").textContent = practical.copy;
    var scope = scopeContent(result);
    document.getElementById("scope-title").textContent = scope.title;
    document.getElementById("scope-copy").textContent = scope.copy;
    var arrangement = extendedSettingArrangementContent(state.practical);
    var arrangementBox = document.getElementById("setting-arrangement-detail");
    if (!arrangementBox) {
      arrangementBox = document.createElement("div");
      arrangementBox.className = "scope-box setting-arrangement-detail";
      arrangementBox.id = "setting-arrangement-detail";
      arrangementBox.innerHTML = '<h3 id="setting-arrangement-title"></h3><p id="setting-arrangement-copy"></p>';
      document.getElementById("scope-box").insertAdjacentElement("afterend", arrangementBox);
    }
    arrangementBox.hidden = !arrangement;
    if (arrangement) {
      document.getElementById("setting-arrangement-title").textContent = arrangement.heading;
      document.getElementById("setting-arrangement-copy").textContent = arrangement.copy;
    }

    var recommendationsSection = document.getElementById("design-languages");
    var bespokeExamplesSection = document.getElementById("bespoke-examples");
    var showCollectionReferences = path === "existing" || path === "adaptation";
    recommendationsSection.hidden = !showCollectionReferences;
    bespokeExamplesSection.hidden = true;
    var hasBespokeExamples = path === "bespoke" && renderBespokeExamples();
    var primaryCta = document.getElementById("result-primary-cta");
    var secondaryCta = document.getElementById("result-secondary-cta");
    primaryCta.firstChild.nodeValue = (result.commercialNextAction && result.commercialNextAction.cta
      ? result.commercialNextAction.cta
      : "Discuss this brief with Andrew") + " ";
    if (showCollectionReferences) {
      secondaryCta.hidden = false;
      renderRecommendations(result, state.answers);
      secondaryCta.href = "#design-languages";
      secondaryCta.textContent = path === "existing" ? "See possible responses" : "See possible starting points";
    } else if (hasBespokeExamples) {
      secondaryCta.hidden = false;
      secondaryCta.href = "#bespoke-examples";
      secondaryCta.textContent = "See relevant bespoke work";
    } else {
      secondaryCta.hidden = true;
    }

    var personal = personalisationContent(path);
    document.getElementById("personalise-heading").textContent = personal.heading;
    document.getElementById("personalise-copy").textContent = personal.copy;
    document.getElementById("commercial-note").textContent = personal.note;

    var conversationHeading = document.getElementById("conversation-heading");
    var discussButton = document.getElementById("discuss-brief-button");
    var actionLabel = result.commercialNextAction && result.commercialNextAction.cta
      ? result.commercialNextAction.cta
      : "Discuss this brief with Andrew";
    conversationHeading.textContent = actionLabel;
    discussButton.firstChild.nodeValue = actionLabel + " ";

    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(function () {
      var resultTitle = document.getElementById("result-title");
      resultTitle.setAttribute("tabindex", "-1");
      resultTitle.focus({ preventScroll: true });
    }, 350);
  }

  function labelAnswers(answers) {
    answers = normaliseConditionalAnswers(answers);
    var labelled = {};
    var activeIds = activeQuestions(answers).map(function (question) { return question.id; });
    questions.forEach(function (question) {
      var asked = activeIds.indexOf(question.id) !== -1;
      labelled[question.id] = {
        value: asked ? answers[question.id] : null,
        label: asked ? answerTextFrom(answers, question.id) : "Not asked for this brief",
        status: asked ? "answered" : "not-applicable"
      };
    });
    return labelled;
  }

  function buildPayload(result, contact) {
    var path = result.designPath || "review";
    var pathCopy = designPathContent(path);
    var practicalCopy = practicalContent(result, state.practical);
    var scope = scopeContent(result);
    var personal = personalisationContent(path);
    var settingArrangement = extendedSettingArrangementContent(state.practical);
    var presentation = recommendationPresentation(path);
    if (result.proposalReview) {
      presentation = {
        eyebrow: "References for a proposal conversation",
        heading: "AG design languages Andrew may use to test the direction",
        intro: "These are conversation references, not approval of a finished surprise ring. Andrew can use them to discuss a safe proposal route while protecting the option to refine the ring together afterwards.",
        close: "You do not need to choose one. The useful response is what feels right, what feels wrong and how much must remain open for the wearer.",
        cardLabel: "Conversation reference"
      };
    }
    var referenceMode = result.recommendationRoles && result.recommendationRoles.referenceMode;
    var referenceLabels = result.recommendationRoles && result.recommendationRoles.referenceLabels || {};
    var recommendationEntries = [
      { role: referenceMode ? referenceLabels.closest : "Closest response", item: result.recommendationRoles && result.recommendationRoles.closest },
      { role: referenceMode ? referenceLabels.alternative : "Credible alternative", item: result.recommendationRoles && result.recommendationRoles.alternative },
      { role: referenceMode ? referenceLabels.curveball : "A different direction worth considering", item: result.recommendationRoles && result.recommendationRoles.curveball }
    ].filter(function (entry) { return !!entry.item; });
    if (!recommendationEntries.length) {
      recommendationEntries = result.recommendations.map(function (item) {
        return { role: presentation.cardLabel, item: item };
      });
    }
    var routeCopy = pathCopy.copy;
    if (result.conflicts && result.conflicts.length) {
      routeCopy += " Your answers also contain " + (result.conflicts.length === 1 ? "one point" : "some points") + " that should be considered rather than averaged away. " +
        result.conflicts.map(function (conflict) { return conflict.explanation; }).join(" ");
    }
    var payload = {
      source: CONFIG.source,
      version: CONFIG.version,
      submittedAt: new Date().toISOString(),
      contact: {
        firstName: contact.firstName,
        email: contact.email,
        wearerName: contact.wearerName || "",
        country: contact.country || "",
        marketingConsent: !!contact.marketingConsent,
        marketingConsentText: contact.marketingConsentText || "",
        marketingConsentAt: contact.marketingConsentAt || "",
        marketingConsentSource: contact.marketingConsentSource || ""
      },
      serviceRequest: "Email my Ring Design Brief",
      marketingConsent: !!contact.marketingConsent,
      marketingConsentText: contact.marketingConsentText || "",
      marketingConsentAt: contact.marketingConsentAt || "",
      marketingConsentSource: contact.marketingConsentSource || "",
      answers: labelAnswers(state.answers),
      practical: Object.assign({}, state.practical),
      result: {
        title: titleForResult(),
        interpretation: interpretationText(state.answers),
        designLanguages: ["existing", "adaptation"].indexOf(result.designPath) !== -1
          ? result.recommendations.map(function (item) { return item.collection.name; }).sort()
          : [],
        internalReferenceLanguages: result.recommendations.map(function (item) { return item.collection.name; }).sort(),
        internalRoutingCollection: result.top.collection.name,
        internalRoutingCollectionUrl: result.top.collection.url,
        designPath: result.designPath,
        designPathLabel: designPathContent(result.designPath).title,
        route: result.route,
        confidenceBand: confidenceLabel(result.confidence),
        evidenceConfidence: Number(result.evidenceConfidence.toFixed(2)),
        decisionConfidence: Number(result.decisionConfidence.toFixed(2)),
        designDirection: Object.assign({}, result.designDirection),
        conflicts: result.conflicts.map(function (conflict) {
          return {
            id: conflict.id,
            severity: conflict.severity,
            explanation: conflict.explanation,
            consequence: conflict.consequence
          };
        }),
        collectionSuitability: {
          credible: result.collectionSuitability.credible,
          blocked: result.collectionSuitability.blocked,
          candidates: result.collectionSuitability.candidates.slice(0, 5).map(function (item) { return item.collection.name; }),
          clientFacingRecommendations: result.collectionSuitability.clientFacingRecommendations.map(function (item) { return item.collection.name; })
        },
        adaptationSuitability: {
          credible: result.adaptationSuitability.credible,
          foundation: result.adaptationSuitability.foundation ? result.adaptationSuitability.foundation.collection.name : null,
          boundedChanges: result.adaptationSuitability.boundedChanges.slice(),
          unresolvedFeasibility: result.adaptationSuitability.unresolvedFeasibility
        },
        bespokeJustification: {
          justified: result.bespokeJustification.justified,
          reasons: result.bespokeJustification.reasons.slice(),
          requiresConversation: result.bespokeJustification.requiresConversation
        },
        recommendationRoles: {
          closest: result.recommendationRoles.closest ? result.recommendationRoles.closest.collection.name : null,
          alternative: result.recommendationRoles.alternative ? result.recommendationRoles.alternative.collection.name : null,
          curveball: result.recommendationRoles.curveball ? result.recommendationRoles.curveball.collection.name : null
        },
        commercialNextAction: Object.assign({}, result.commercialNextAction),
        display: {
          title: titleForResult(),
          interpretation: interpretationText(state.answers),
          phrases: resultPhrases(state.answers),
          wearer: {
            heading: wearerHeading(state.answers.presence),
            copy: wearerCopy(state.answers)
          },
          relationship: isSelfWearerOnly(state.answers) ? null : {
            heading: relationshipHeading(state.answers),
            copy: relationshipCopy(state.answers)
          },
          confidenceCopy: evidenceExplainer(state.answers),
          expression: {
            heading: expressionHeading(result),
            copy: expressionCopy(state.answers, result)
          },
          glance: glanceItems(state.answers, state.practical).map(function (item) {
            return { label: item[0], value: item[1] };
          }),
          answerRecap: answerRecapItems(state.answers).map(function (item) {
            return { label: item[0], value: item[1] };
          }),
          route: { title: pathCopy.title, copy: routeCopy, capacity: pathCopy.capacity || "" },
          practical: { heading: practicalCopy.heading, copy: practicalCopy.copy },
          settingArrangement: settingArrangement,
          scope: { title: scope.title, copy: scope.copy },
          personalisation: { heading: personal.heading, copy: personal.copy, note: personal.note },
          nextAction: Object.assign({}, result.commercialNextAction),
          discussUrl: CONFIG.contactUrl || "https://andrewgeoghegan.com/pages/contact",
          recommendations: {
            visible: path === "existing" || path === "adaptation",
            eyebrow: presentation.eyebrow,
            heading: presentation.heading,
            intro: presentation.intro,
            close: presentation.close,
            items: recommendationEntries.map(function (entry) {
              var item = entry.item;
              return {
                role: entry.role,
                title: item.collection.name,
                url: item.collection.url,
                image: collectionImageFor(item.collection, state.answers),
                fallbackImage: item.collection.image,
                reason: recommendationReason(item, state.answers) + (["A different direction worth considering", "Wildcard reference"].indexOf(entry.role) !== -1
                  ? " This is included as a useful contrast, not because it matches every answer."
                  : "")
              };
            })
          }
        },
        internalRoutingAmbiguous: result.ambiguousRouting,
        internalTopGap: Number(result.gap.toFixed(2)),
        privateReviewCandidate: result.privateReview,
        proposalReview: result.proposalReview,
        internalScores: result.recommendations.map(function (item) {
          return {
            collection: item.collection.name,
            final: Number(item.finalScore.toFixed(2)),
            wearer: Number(item.wearerScore.toFixed(2)),
            relationship: Number.isFinite(item.relationshipScore) ? Number(item.relationshipScore.toFixed(2)) : null,
            practicalPenalty: item.practicalPenalty
          };
        })
      }
    };
    payload.emailBriefText = emailBriefText(result, contact);
    return payload;
  }

  function emailBriefText(result, contact) {
    var path = result.designPath || "review";
    var pathCopy = designPathContent(path);
    var practical = practicalContent(result, state.practical);
    var scope = scopeContent(result);
    var lines = [
      "Andrew Geoghegan Ring Design Brief",
      "",
      contact.firstName ? "Prepared for " + contact.firstName : "",
      "",
      "What the ring should express",
      interpretationText(state.answers),
      "",
      "Direction at a glance",
      resultPhrases(state.answers).join(" · "),
      "",
      expressionHeading(result),
      expressionCopy(state.answers, result),
      "",
      "Your brief at a glance"
    ].filter(Boolean);

    glanceItems(state.answers, state.practical).forEach(function (item) {
      lines.push(item[0] + ": " + item[1]);
    });

    lines.push("", "Suggested starting point", pathCopy.title, pathCopy.copy, "", practical.heading, practical.copy, "", scope.title, scope.copy);

    var settingArrangement = extendedSettingArrangementContent(state.practical);
    if (settingArrangement) {
      lines.push("", settingArrangement.heading, settingArrangement.copy);
    }

    if (path === "existing" || path === "adaptation") {
      var names = result.recommendations.map(function (item) { return item.collection.name; }).sort();
      if (names.length) lines.push("", "Relevant Andrew Geoghegan pieces to explore", names.join(", ") + ".");
    }

    lines.push("", "To discuss this brief with Andrew, reply to this email or visit " + (CONFIG.contactUrl || "https://andrewgeoghegan.com/pages/contact") + ".");
    return lines.join("\n");
  }

  function hubspotBriefReady() {
    return !!(
      CONFIG.hubspotPortalId &&
      CONFIG.hubspotBriefFormGuid &&
      CONFIG.hubspotMarketingSubscriptionTypeId
    );
  }

  function briefServiceReady() {
    return !!CONFIG.briefServiceEndpoint;
  }

  function hubspotDeliveryReady() {
    return !!(CONFIG.hubspotPortalId && CONFIG.hubspotDeliveryFormGuid);
  }

  function hubspotBriefSubmission(payload) {
    var briefProperty = CONFIG.hubspotBriefProperty || "ring_design_brief_json";
    return {
      fields: [
        { name: "email", value: payload.contact.email },
        { name: "firstname", value: payload.contact.firstName },
        { name: "wearer_first_name", value: payload.contact.wearerName || "" },
        { name: "country", value: payload.contact.country || "" },
        { name: "engagement_questionnaire", value: "true" },
        { name: "ring_design_brief_email", value: payload.emailBriefText || "" },
        { name: briefProperty, value: JSON.stringify(payload) }
      ],
      context: {
        pageUri: window.location.href,
        pageName: document.title
      },
      legalConsentOptions: {
        consent: {
          consentToProcess: true,
          text: "I agree to receive Andrew Geoghegan marketing emails, including The Friday Edit.",
          communications: [{
            value: true,
            subscriptionTypeId: Number(CONFIG.hubspotMarketingSubscriptionTypeId),
            text: "I agree to receive Andrew Geoghegan marketing emails, including The Friday Edit."
          }]
        }
      }
    };
  }

  async function submitHubspotBrief(payload) {
    var endpoint = "https://api.hsforms.com/submissions/v3/integration/submit/" +
      encodeURIComponent(CONFIG.hubspotPortalId) + "/" + encodeURIComponent(CONFIG.hubspotBriefFormGuid);
    var response = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(hubspotBriefSubmission(payload))
    });
    if (!response.ok) throw new Error("HubSpot brief submission returned " + response.status);
  }

  async function createPrivateBrief(payload) {
    var contact = payload.contact || {};
    var response = await fetch(CONFIG.briefServiceEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Object.assign({}, payload, {
        email: contact.email || "",
        firstName: contact.firstName || "",
        wearerFirstName: contact.wearerName || "",
        country: contact.country || ""
      }))
    });
    if (!response.ok) throw new Error("Private brief service returned " + response.status);
    var result = await response.json();
    if (!result.briefUrl) throw new Error("Private brief service did not return a brief URL.");
    return result;
  }

  async function submitHubspotDelivery(payload, briefUrl) {
    var endpoint = "https://api.hsforms.com/submissions/v3/integration/submit/" +
      encodeURIComponent(CONFIG.hubspotPortalId) + "/" + encodeURIComponent(CONFIG.hubspotDeliveryFormGuid);
    var response = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        fields: [
          { name: "email", value: payload.contact.email },
          { name: "ring_design_brief_url", value: briefUrl }
        ],
        context: {
          pageUri: window.location.href,
          pageName: document.title
        }
      })
    });
    if (!response.ok) throw new Error("HubSpot delivery submission returned " + response.status);
  }

  async function submitPayload(payload) {
    state.lastPayload = payload;
    try {
      sessionStorage.setItem("ag-engagement-design-brief-last", JSON.stringify(payload));
    } catch (error) {
      console.warn("Design Brief preview could not be stored in this session.", error);
    }
    if (CONFIG.formEndpoint) {
      var response = await fetch(CONFIG.formEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error("Submission endpoint returned " + response.status);
      return { preview: false };
    }
    if (hubspotBriefReady() && briefServiceReady() && hubspotDeliveryReady()) {
      await submitHubspotBrief(payload);
      var privateBrief = await createPrivateBrief(payload);
      await submitHubspotDelivery(payload, privateBrief.briefUrl);
      return { preview: false, hubspot: true, briefUrl: privateBrief.briefUrl };
    }
    return { preview: true };
  }

  function validateConsultationImage(file) {
    if (!file) return "";
    var allowed = ["image/jpeg", "image/png", "image/webp"];
    if (allowed.indexOf(file.type) === -1) return "Please choose a JPEG, PNG or WebP image.";
    if (file.size > 10 * 1024 * 1024) return "Please choose an image no larger than 10MB.";
    return "";
  }

  function clearUpload() {
    var input = document.getElementById("consultation-image");
    var preview = document.getElementById("upload-preview");
    if (input) input.value = "";
    if (uploadPreviewUrl) {
      URL.revokeObjectURL(uploadPreviewUrl);
      uploadPreviewUrl = "";
    }
    document.getElementById("upload-preview-image").src = "";
    document.getElementById("upload-file-name").textContent = "";
    preview.hidden = true;
  }

  function showUpload(file) {
    if (uploadPreviewUrl) URL.revokeObjectURL(uploadPreviewUrl);
    uploadPreviewUrl = URL.createObjectURL(file);
    document.getElementById("upload-preview-image").src = uploadPreviewUrl;
    document.getElementById("upload-file-name").textContent = file.name;
    document.getElementById("upload-preview").hidden = false;
  }

  function buildConsultationPayload(file) {
    var consultationFirstName = document.getElementById("consultation-first-name").value.trim();
    var consultationEmail = document.getElementById("consultation-email").value.trim();
    if (!state.contact.firstName && consultationFirstName) state.contact.firstName = consultationFirstName;
    if (!state.contact.email && consultationEmail) state.contact.email = consultationEmail;
    return {
      source: CONFIG.source,
      version: CONFIG.version,
      submittedAt: new Date().toISOString(),
      serviceRequest: state.result && state.result.commercialNextAction
        ? state.result.commercialNextAction.cta
        : "Discuss this Design Brief with Andrew",
      commercialNextAction: state.result && state.result.commercialNextAction
        ? Object.assign({}, state.result.commercialNextAction)
        : null,
      requestPrivateDigitalAppointment: document.getElementById("request-appointment").checked,
      contact: {
        firstName: state.contact.firstName || consultationFirstName,
        email: state.contact.email || consultationEmail,
        wearerName: state.contact.wearerName || "",
        country: state.contact.country || ""
      },
      message: document.getElementById("consultation-message").value.trim(),
      referenceLink: document.getElementById("consultation-link").value.trim(),
      image: file ? { name: file.name, type: file.type, size: file.size } : null,
      designBrief: state.lastPayload
    };
  }

  async function submitConsultation(payload, file) {
    state.lastConsultationPayload = payload;
    if (!CONFIG.consultationEndpoint) return { preview: true };
    var formData = new FormData();
    formData.append("payload", JSON.stringify(payload));
    if (file) formData.append("image", file, file.name);
    var response = await fetch(CONFIG.consultationEndpoint, {
      method: "POST",
      body: formData
    });
    if (!response.ok) throw new Error("Consultation endpoint returned " + response.status);
    return { preview: false };
  }

  function shareText() {
    var atGlance = glanceItems(state.answers, state.practical);
    var languages = state.result.recommendations.map(function (item) { return item.collection.name; }).sort().join(", ");
    var path = state.result.designPath || "review";
    var pathCopy = designPathContent(path);
    var lines = [
      "Andrew Geoghegan Ring Design Brief",
      "",
      interpretationText(state.answers),
      "",
      "Suggested starting point: " + pathCopy.title + ".",
      pathCopy.copy,
      "",
      "Design Brief at a glance"
    ];
    atGlance.forEach(function (item) { lines.push(item[0] + ": " + item[1]); });
    if (path === "existing" || path === "adaptation") {
      lines.push("", "AG reference points to explore: " + languages + ".");
    }
    lines.push("", "This is a brief for the ring, not a finished design, quotation or product recommendation.");
    if (CONFIG.publicUrl) lines.push("", CONFIG.publicUrl);
    return lines.join("\n");
  }

  async function shareBrief() {
    if (!state.result) return;
    var data = {
      title: "My Andrew Geoghegan Ring Design Brief",
      text: shareText()
    };
    if (navigator.share) {
      try {
        await navigator.share(data);
        return;
      } catch (error) {
        if (error && error.name === "AbortError") return;
      }
    }
    var subject = encodeURIComponent(data.title);
    var body = encodeURIComponent(data.text);
    window.location.href = "mailto:?subject=" + subject + "&body=" + body;
  }

  var printOpenStates = [];

  function preparePrint() {
    printOpenStates = Array.from(document.querySelectorAll(".brief-detail")).map(function (detail) { return detail.open; });
    document.querySelectorAll(".brief-detail").forEach(function (detail) { detail.open = true; });
  }

  function restoreAfterPrint() {
    document.querySelectorAll(".brief-detail").forEach(function (detail, index) {
      detail.open = !!printOpenStates[index];
    });
  }

  function reset() {
    state.current = 0;
    state.answers = {};
    state.practical = {};
    state.contact = {};
    state.result = null;
    state.lastPayload = null;
    state.lastConsultationPayload = null;
    elements.form.reset();
    var consultationForm = document.getElementById("consultation-form");
    if (consultationForm) consultationForm.reset();
    if (uploadPreviewUrl) {
      URL.revokeObjectURL(uploadPreviewUrl);
      uploadPreviewUrl = "";
    }
    var uploadPreview = document.getElementById("upload-preview");
    if (uploadPreview) uploadPreview.hidden = true;
    var consultationStatus = document.getElementById("consultation-status");
    if (consultationStatus) consultationStatus.hidden = true;
    var consultationError = document.getElementById("consultation-error");
    if (consultationError) consultationError.hidden = true;
    var discussButton = document.getElementById("discuss-brief-button");
    if (discussButton) {
      discussButton.disabled = false;
      discussButton.removeAttribute("data-delivered");
      discussButton.innerHTML = 'Discuss this brief with Andrew <span aria-hidden="true">→</span>';
    }
    document.querySelectorAll(".brief-detail").forEach(function (detail) { detail.open = false; });
    try { sessionStorage.removeItem("ag-engagement-design-brief-last"); } catch (error) { /* no-op */ }
    elements.result.hidden = true;
    var deliveryWarning = document.getElementById("delivery-warning");
    if (deliveryWarning) deliveryWarning.remove();
    elements.quiz.hidden = true;
    elements.intro.hidden = false;
    elements.proof.hidden = false;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  document.getElementById("start-button").addEventListener("click", function () {
    elements.intro.hidden = true;
    elements.proof.hidden = true;
    elements.result.hidden = true;
    elements.quiz.hidden = false;
    renderQuestion();
  });

  elements.next.addEventListener("click", function () {
    if (elements.next.disabled) return;
    var visibleQuestions = activeQuestions(state.answers);
    if (state.current < visibleQuestions.length) {
      state.current += 1;
      renderQuestion();
    } else {
      showContact();
    }
  });

  elements.back.addEventListener("click", function () {
    if (!elements.contactStage.hidden) {
      state.current = activeQuestions(state.answers).length;
      renderQuestion();
    } else if (state.current > 0) {
      state.current -= 1;
      renderQuestion();
    }
  });

  document.getElementById("review-answers").addEventListener("click", function () {
    state.current = activeQuestions(state.answers).length;
    renderQuestion();
  });


  elements.form.addEventListener("submit", async function (event) {
    event.preventDefault();
    elements.contactError.hidden = true;
    if (!elements.form.reportValidity()) return;

    var submitButton = elements.form.querySelector('button[type="submit"]');
    var original = submitButton.innerHTML;
    submitButton.disabled = true;
    submitButton.textContent = "Preparing your brief...";

    var contact = {
      firstName: document.getElementById("first-name").value.trim(),
      email: document.getElementById("email").value.trim(),
      wearerName: document.getElementById("wearer-name").value.trim(),
      country: document.getElementById("country").value.trim(),
      marketingConsent: true,
      marketingConsentText: document.getElementById("marketing-consent-copy").textContent.trim(),
      marketingConsentAt: new Date().toISOString(),
      marketingConsentSource: "ring-direction-email-gate-primary-action"
    };

    var result = computeResults(state.answers, state.practical, contact);
    var payload = buildPayload(result, contact);
    var deliveryError = null;
    var deliveryResult = null;
    try {
      deliveryResult = await submitPayload(payload);
    } catch (error) {
      deliveryError = error;
      console.error("The Design Brief email request could not be delivered.", error);
    }

    if (deliveryResult && deliveryResult.hubspot) {
      showDeliveryConfirmation(contact);
    } else {
      renderResult(result, contact);
    }
    if (deliveryError) {
      var existingNotice = document.getElementById("delivery-warning");
      if (existingNotice) existingNotice.remove();
      var notice = document.createElement("p");
      notice.id = "delivery-warning";
      notice.className = "commercial-note";
      notice.textContent = "Your Design Brief is visible below, but the email copy could not be sent. Please save this page and try again later.";
      document.querySelector(".result-copy-inner").appendChild(notice);
    }
    submitButton.disabled = false;
    submitButton.innerHTML = original;
  });

  document.getElementById("consultation-image").addEventListener("change", function (event) {
    var errorElement = document.getElementById("consultation-error");
    errorElement.hidden = true;
    var file = event.target.files && event.target.files[0];
    if (!file) {
      clearUpload();
      return;
    }
    var error = validateConsultationImage(file);
    if (error) {
      clearUpload();
      errorElement.textContent = error;
      errorElement.hidden = false;
      return;
    }
    showUpload(file);
  });

  document.getElementById("remove-upload").addEventListener("click", clearUpload);

  document.getElementById("consultation-form").addEventListener("submit", async function (event) {
    event.preventDefault();
    var form = event.currentTarget;
    var errorElement = document.getElementById("consultation-error");
    var statusElement = document.getElementById("consultation-status");
    errorElement.hidden = true;
    statusElement.hidden = true;
    if (!form.reportValidity()) return;

    var file = document.getElementById("consultation-image").files[0] || null;
    var imageError = validateConsultationImage(file);
    if (imageError) {
      errorElement.textContent = imageError;
      errorElement.hidden = false;
      return;
    }

    var button = document.getElementById("discuss-brief-button");
    var original = button.innerHTML;
    button.disabled = true;
    button.textContent = "Preparing your conversation...";
    try {
      var payload = buildConsultationPayload(file);
      var outcome = await submitConsultation(payload, file);
      statusElement.textContent = outcome.preview
        ? "Preview only: on the live site, this would send your Design Brief and anything you added to Andrew. If selected, it would also request a private digital appointment. Nothing has been sent from this preview."
        : "Your Design Brief, together with anything you added, has been sent to Andrew. If you requested a private digital appointment, he can reply to arrange it.";
      if (!outcome.preview) button.dataset.delivered = "true";
      statusElement.hidden = false;
      statusElement.focus({ preventScroll: true });
    } catch (error) {
      console.error("The conversation request could not be delivered.", error);
      errorElement.textContent = "Your request could not be sent. Your details are still here, so you can try again without re-entering them.";
      errorElement.hidden = false;
    } finally {
      if (button.dataset.delivered === "true") {
        button.disabled = true;
        button.textContent = "Sent to Andrew";
      } else {
        button.disabled = false;
        button.innerHTML = original;
      }
    }
  });

  document.getElementById("share-result").addEventListener("click", shareBrief);
  window.addEventListener("beforeprint", preparePrint);
  window.addEventListener("afterprint", restoreAfterPrint);
  document.getElementById("print-result").addEventListener("click", function () { window.print(); });
  document.getElementById("retake-button").addEventListener("click", reset);

  var demoBanner = document.getElementById("demo-banner");
  if (CONFIG.formEndpoint && CONFIG.consultationEndpoint) {
    demoBanner.hidden = true;
  } else if (CONFIG.formEndpoint) {
    demoBanner.textContent = "The Design Brief email is connected. The Andrew conversation form remains in preview mode";
  } else if (CONFIG.consultationEndpoint) {
    demoBanner.textContent = "The Andrew conversation form is connected. Design Brief email delivery remains in preview mode";
  }

  window.ERDB_TEST_API = {
    questions: questions,
    practicalStep: practicalStep,
    collections: collections,
    collectionImageFor: collectionImageFor,
    state: state,
    scoreCollection: scoreCollection,
    computeResults: computeResults,
    classifyDesignPath: classifyDesignPath,
    honestCollectionCandidates: honestCollectionCandidates,
    designDirectionFromAnswers: designDirectionFromAnswers,
    detectConflicts: detectConflicts,
    decisionConfidenceScore: decisionConfidenceScore,
    assessCollectionSuitability: assessCollectionSuitability,
    assessAdaptationSuitability: assessAdaptationSuitability,
    assessBespokeJustification: assessBespokeJustification,
    recommendationRolesFor: recommendationRolesFor,
    commercialNextActionFor: commercialNextActionFor,
    activeQuestions: activeQuestions,
    isSelfWearerOnly: isSelfWearerOnly,
    isSoloPartnerChooser: isSoloPartnerChooser,
    relationshipMeaningRelevant: relationshipMeaningRelevant,
    normaliseConditionalAnswers: normaliseConditionalAnswers,
    designPathContent: designPathContent,
    buildPayload: buildPayload,
    hubspotBriefReady: hubspotBriefReady,
    hubspotBriefSubmission: hubspotBriefSubmission,
    buildConsultationPayload: buildConsultationPayload,
    validateConsultationImage: validateConsultationImage,
    interpretationText: interpretationText,
    glanceItems: glanceItems,
    shareText: shareText,
    preparePrint: preparePrint,
    restoreAfterPrint: restoreAfterPrint,
    renderQuestion: renderQuestion,
    renderResult: renderResult,
    reset: reset
  };
})();
